import {
  Component,
  HostListener,
  inject,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  OnDestroy,
  ElementRef,
  DestroyRef
} from '@angular/core';
import {
  metaInfo,
  currentAppFullData,
  updateStatus,
  newlyCreatedAppErr
} from 'src/app/STORE/selectors/applifecycle.selector';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RtIconRocket02Component } from '@rt-icons/rt-icon-rocket-02/rt-icon-rocket-02.component';
import { RtIconCopy03Component } from '@rt-icons/rt-icon-copy-03/rt-icon-copy-03.component';
import { RtIconSpeedometer03Component } from '@rt-icons/rt-icon-speedometer-03/rt-icon-speedometer-03.component';
import { RtIconChevronRightComponent } from '@rt-icons/rt-icon-chevron-right/rt-icon-chevron-right.component';
import { RtIconSearchMdComponent } from '@rt-icons/rt-icon-search-md/rt-icon-search-md.component';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuItem, TreeNode } from 'primeng/api';
import { SearchOverlayComponent } from '../search-overlay/search-overlay.component';
import { BrandIconComponent } from '@svg-icons/brand-icon/brand-icon.component';
import { ArrowUpIconComponent } from '@svg-icons/arrow-up-icon/arrow-up-icon.component';
import { FileXIconComponent } from '@svg-icons/file-x-icon/file-x-icon.component';
import { ProductLogoComponent } from 'src/app/svg-icons/product-logo/product-logo.component';
import { PageIconComponent } from '@svg-icons/page-icon/page-icon.component';
import { InboxIconComponent } from '@svg-icons/inbox-icon/inbox-icon.component';
import { MessageIconComponent } from '@svg-icons/message-icon/message-icon.component';
import { ToggleViewIconComponent } from '@svg-icons/toggle-view-icon/toggle-view-icon.component';
import { SpinnerIconComponent } from '@svg-icons/spinner-icon/spinner-icon.component';
import { BlueTickIconComponent } from '@svg-icons/blue-tick-icon/blue-tick-icon.component';
import { RouterModule, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { HttpHeaders } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UtilService } from 'src/app/services/util.service';
import { AnnotationToolService } from 'src/app/services/annotation-tool.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { ApplicationDetailsComponent } from './application-details/application-details.component';
import { Application } from 'src/app/services/application.service';
import { BoxLayoutComponent } from 'src/app/components/box-layout/box-layout.component';
import { SharedModule } from 'src/app/components/shared.module';
import { filter, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { v4 as uuidv4 } from 'uuid';
import { ApiConstants } from 'src/app/base/api-constants';
import { userData } from 'src/app/STORE/selectors/auth.selector';

import { sentApps } from 'src/app/STORE/actions/applifecycle.actions';
import { FsBaseService } from 'src/app/services/fs-base.service';
import { BlueprintStateService } from '../../blueprint/services/blueprint-state.service';
import { HeaderService } from 'src/app/services/header.service';
import { RefreshTimeAgoDirective } from 'src/app/directives/refresh-time-ago.directive';
import { mapSqlTypeToUiType } from './main-layout.util';

import {
  ChatAction,
  ChatMessage,
  PlanStructure,
  ChatMessageType,
  ChatMessageStatus,
  SESSION_MERGE_STATUS,
  SESSION_STATUS,
  SESSION_MODE,
  SESSION_DRIVEN_MODE
} from './main-layout.model';
import { BackArrowIconComponent } from '@svg-icons/back-arrow-icon/back-arrow-icon.component';
import { CloseIconComponent } from '@svg-icons/close-icon/close-icon.component';
import { LightBulbIconComponent } from '@svg-icons/light-bulb-icon/light-bulb-icon.component';
import { InfinityIconComponent } from '@svg-icons/infinity-icon/infinity-icon.component';
import { QnaQuestionCardComponent, SessionQuestion } from './qna-question-card/qna-question-card.component';

/**
 * Main Layout Component
 *
 * Primary application layout with chat panel, preview pane, and toolbar.
 * Handles resizing, chat interactions, and global keyboard shortcuts.
 *
 * @component
 * @example
 * <app-main-layout></app-main-layout>
 */

import { getMockMessagePayload } from '@mock-data/app/pages/home/main-layout/mock-data';
import { DialogService } from 'primeng/dynamicdialog';
import { ShareSessionComponent } from './share-session/share-session.component';
import { RenameSessionComponent } from './rename-session/rename-session.component';
import { RtIconCheckCircleComponent } from '@rt-icons/rt-icon-check-circle/rt-icon-check-circle.component';
import { RtIconPlaceholderComponent } from '@rt-icons/rt-icon-placeholder/rt-icon-placeholder.component';
import { RtIconLoading02Component } from '@rt-icons/rt-icon-loading-02/rt-icon-loading-02.component';
import { RtIconXCircleComponent } from '@rt-icons/rt-icon-x-circle/rt-icon-x-circle.component';
import { AppStateService } from 'src/app/services/app-state.service';
import { RtIconMessageTextSquare01Component } from '@rt-icons/rt-icon-message-text-square-01/rt-icon-message-text-square-01.component';
import { RtIconDatabase02Component } from '@rt-icons/rt-icon-database-02/rt-icon-database-02.component';
import { RtIconCube01Component } from '@rt-icons/rt-icon-cube-01/rt-icon-cube-01.component';
import { RtIconFilterLinesComponent } from '@rt-icons/rt-icon-filter-lines/rt-icon-filter-lines.component';
import { RtIconStatusComponent } from '@rt-icons/rt-icon-status/rt-icon-status.component';
import { CONVERSATION_STATUS } from 'src/app/base/companion-constants';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  providers: [DialogService],
  imports: [
    RtIconCheckCircleComponent,
    RtIconPlaceholderComponent,
    RtIconLoading02Component,
    RtIconXCircleComponent,
    RtIconDatabase02Component,
    CloseIconComponent,
    CommonModule,
    FormsModule,
    BoxLayoutComponent,
    SearchOverlayComponent,
    RouterModule,
    TooltipModule,
    ApplicationDetailsComponent,
    TreeTableModule,
    CheckboxModule,
    SelectModule,
    TableModule,
    DialogModule,
    MenuModule,
    TieredMenuModule,
    OverlayPanelModule,
    BrandIconComponent,
    ArrowUpIconComponent,
    FileXIconComponent,
    ProductLogoComponent,
    PageIconComponent,
    InboxIconComponent,
    MessageIconComponent,
    ToggleViewIconComponent,
    SpinnerIconComponent,
    BlueTickIconComponent,
    AngularSvgIconModule,
    SharedModule,
    TranslateModule,
    RefreshTimeAgoDirective,
    BackArrowIconComponent,
    LightBulbIconComponent,
    InfinityIconComponent,
    QnaQuestionCardComponent,
    RtIconRocket02Component,
    RtIconCopy03Component,
    RtIconChevronRightComponent,
    RtIconSearchMdComponent,
    RtIconMessageTextSquare01Component,
    RtIconCube01Component,
    RtIconFilterLinesComponent,
    RtIconStatusComponent,
    RtIconSpeedometer03Component
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  readonly ChatMessageType = ChatMessageType;
  readonly ChatMessageStatus = ChatMessageStatus;
  readonly SESSION_MERGE_STATUS = SESSION_MERGE_STATUS;
  readonly SESSION_MODE = SESSION_MODE;
  readonly SESSION_STATUS = SESSION_STATUS;
  readonly SESSION_DRIVEN_MODE = SESSION_DRIVEN_MODE;

  annotationToolService = inject(AnnotationToolService);
  selectedApp: Application | null = null;
  detailedDialogVisible = false;
  isContentCollapsed = false; // State to toggle Box Layout visibility

  dataTypes = [
    { name: 'String', value: 'String' },
    { name: 'Number', value: 'Number' },
    { name: 'Drop Down', value: 'Dropdown' },
    { name: 'Look Up', value: 'Lookup' },
    { name: 'Date Time', value: 'DateTime' },
    { name: 'Boolean', value: 'Boolean' },
    { name: 'Text', value: 'Text' },
    { name: 'CheckBox', value: 'Checkbox' },
    { name: 'Checkbox Group', value: 'Checkboxgroup' },
    { name: 'Currency', value: 'Currency' },
    { name: 'Date Only', value: 'Date' },
    { name: 'Double', value: 'Double' },
    { name: 'Email', value: 'Email' },
    { name: 'File Attachment', value: 'File Attachments' },
    { name: 'Image Carousel', value: 'Image Carousel' },
    { name: 'Radio Button', value: 'Radio' },
    { name: 'URL', value: 'URL' },
    { name: 'Yes No', value: 'Yes No' },
    { name: 'Color', value: 'Color' },
    { name: 'Auto Number', value: 'Auto-number' }
  ];

  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly utilService = inject(UtilService);
  private readonly appGlobalService = inject(AppGlobalService);
  private readonly httpBaseService = inject(HttpBaseService);
  private readonly fsBaseService = inject(FsBaseService);
  private readonly headerService = inject(HeaderService);
  private readonly store = inject(Store);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  private readonly location = inject(Location);
  private readonly dialogService = inject(DialogService);
  private readonly blueprintStateService = inject(BlueprintStateService);

  private readonly appStateService = inject(AppStateService);

  @ViewChild('chatTextarea') chatTextarea!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('chatScrollContainer') chatScrollContainer!: ElementRef<HTMLDivElement>;

  /** Change Request State */
  isChangeMode = false;
  chatboxMode: 'ideate' | 'auto' | null = null;
  changeRequestTarget = '';
  changeRequestMessageIndex: number | null = null;
  changeRequestAction: ChatAction | null = null;

  /** Chat panel collapse state */
  isChatCollapsed = false;

  changesetViewMode: 'system_only' | 'session_and_system' | 'session_vs_system' = 'session_vs_system';

  /** Chat panel width in pixels */
  chatWidth = 420;
  readonly collapsedChatWidth = 55;
  promptboxHeight: string = '30px';

  /** Resize drag state */
  isResizing = false;

  /** Last mouse X during a resize drag, used to detect drag direction */
  private lastResizeClientX = 0;

  QnAChatMessage?: any;

  pendingPlanOutlineMsg: ChatMessage | null = null;
  pendingTodosStats: any[] | null = null;

  isSessionSummaryExpanded = false;

  isQnADomStateActive = false;
  isQnACardVisible = false;
  qaPreferredAnswers?: Record<string, unknown>;
  qaConfig?: any;
  questions: SessionQuestion[] = [];

  /** Current chat input value */
  chatInput = '';

  /** Currently selected file attachment via chat box */
  attachedFile: { name: string; content: string; type: string } | null = null;

  /** Chat message history */
  messages: ChatMessage[] = [];

  /** Queue for incoming assistant messages while one is currently streaming */
  private readonly messageQueue: ChatMessage[] = [];

  /** Local cache for Firestore messages to handle stateChanges delta */
  private readonly firestoreMessagesMap = new Map<string, any>();

  /** Map of active streaming intervals by message ID */
  private readonly streamingIntervals = new Map<string, any>();

  /** Local cache for Firestore conversation to handle stateChanges delta */
  private readonly firestoreConversationMap = new Map<string, any>();

  isChatDisabled = true;

  Flags = {
    isSessionActionsDisabled: true
  };

  /** Firebase subscriptions */
  private messageSub?: Subscription;
  private conversationSub?: Subscription;

  private sessionListSub?: Subscription;
  private readonly destroyRef = inject(DestroyRef);

  /** Configuration details of the current/active session/app */

  activeSession: any = {};
  private sessionDetailSub?: Subscription;

  activeBPSession: any = {};
  private blueprintDetailSub?: Subscription;

  appDetail: any = {};
  private appDetailSub?: Subscription;

  /** Menu dropdown state */
  isMenuOpen = false;

  /** Search overlay visibility state */
  isSearchOverlayOpen = false;

  /** Search feature disabled state */
  isSearchDisabled = true;

  /** App Management Page state */
  isAppManagementPage = false;

  /** User display name */
  userName = 'User';

  /** Current conversational flow state */
  activeFlow: 'none' | 'add-roles' | 'add-tables' | 'add-app' = 'none';

  /** Current tracked App ID to prevent unnecessary reloads */
  currentAppId: string = '';

  /** Current Session ID for AI conversation */
  private sessionId = '';

  isTodoCardCollapsed = true;

  isSessionConfirmationPending = false;
  sessionConfirmationType: 'approve' | 'reject' | null = null;

  /** Current Conversation ID for AI conversation */
  private conversationId = '';

  /** available sessions for user to pick */
  appSessions: any[] = [];
  appMetaInfo: any = {};

  /** Flag to manage visibility of sessions panel instead of clearing the metadata array */
  isSessionsPanelOpen = false;

  /** Flag to track new active session state */
  isNewSessionActive = false;

  /** Flag to track session loading state */
  isLoadingSessions = true;

  // Pagination parameters
  hasMoreHistory = true;
  isLoadingHistory = false;
  historyCursor: string | null = null;
  // Easily tweakable for testing
  readonly CONVERSATION_FETCH_LIMIT = 10;

  isBetaAccessPrivilegeConsumable = false;
  isBetaAccessPrivilegeConsumableForUser = false;

  codeEditorPage$: Subscription | null = null;

  private skipStreaming = {};

  sessionMenuItems: MenuItem[];
  sessionMenuItemsMap: any = {};
  isFilterMenuOpen = false;
  ownerList: any[] = [];
  ownerSearchQuery = '';

  get selectedOwnerItems() {
    const selected = this.ownerList.filter((o) => this.activeFilters.owner.has(o.id));
    if (!this.ownerSearchQuery.trim()) {
      return selected;
    }
    const q = this.ownerSearchQuery.toLowerCase();
    return selected.filter((o) => o.name.toLowerCase().includes(q));
  }

  get unselectedFilteredOwnerItems() {
    const unselected = this.ownerList.filter((o) => !this.activeFilters.owner.has(o.id));
    if (!this.ownerSearchQuery.trim()) {
      return unselected;
    }
    const q = this.ownerSearchQuery.toLowerCase();
    return unselected.filter((o) => o.name.toLowerCase().includes(q));
  }

  trackByOwner(index: number, item: any) {
    return item.id;
  }

  get filteredOwnerList() {
    if (!this.ownerSearchQuery) return this.ownerList;
    const q = this.ownerSearchQuery.toLowerCase();
    return this.ownerList.filter((o) => o.name.toLowerCase().includes(q));
  }

  get filterBadgeCount() {
    return this.activeFilters.type.size + this.activeFilters.mergeStatus.size + this.activeFilters.owner.size;
  }

  ngOnInit() {
    this.constructSessionMenuItems();

    this.updateOwnerFilters();

    this.appStateService.initialize();

    this.initializeDefaults();

    this.checkRoute();

    this.store
      .select(userData)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((userInfo: any) => {
        if (userInfo) {
          // Refresh the user-level vibe flags from the latest authenticated user before
          // recomputing the consumable state. This keeps other tabs in sync when RAI mode
          // is toggled elsewhere (the change arrives via the setUser dispatch), so the body
          // mode classes flip correctly instead of rendering both vibe and non-vibe elements.
          if (userInfo.email) {
            this.appGlobalService.write('isBetaAccessEnabled', userInfo.betaAccess || false);
            this.appGlobalService.write('raiModeEnabledForUser', userInfo.raiModeEnabled || false);
          }

          this.handleBetaAccessPrivilegeRevisions();
        }
      });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      // reason for LHS:chat and RHS:toolbar didn't came
      this.checkRoute();

      this.handleBetaAccessPrivilegeRevisions();

      // Silently restore sessionId into the URL if Angular's router stripped it
      if (this.sessionId) {
        const urlTree = this.router.parseUrl(this.router.url);
        if (urlTree.queryParams['sessionId'] !== this.sessionId) {
          urlTree.queryParams['sessionId'] = this.sessionId;
          this.location.replaceState(this.router.serializeUrl(urlTree));
        }
      }
    });
  }

  ngOnDestroy() {
    this.appGlobalService.setChatPending(false);
    document.documentElement.style.removeProperty('--vibe-left-rail-width');
    document.body.classList.remove('rail-resizing');
    this.resetConnections();
  }

  /**
   * Handles chat panel resize during drag
   * @param event - Mouse move event
   */
  @HostListener('document:mousemove', ['$event'])
  resize(event: MouseEvent) {
    if (!this.isResizing) {
      return;
    }

    const newWidth = event.clientX;
    const minWidth = 260; // Below this, the rail is considered collapse-eligible
    const maxWidth = 600; // Do not allow dragging wider than this

    // Movement since the last frame. A small threshold absorbs natural mouse
    // jitter so a rightward drag is never misread as a leftward one.
    const delta = newWidth - this.lastResizeClientX;
    this.lastResizeClientX = newWidth;
    const draggingLeft = delta < -2;

    // While collapsed, do nothing until the cursor crosses the min expanded
    // width (260px). Only past that point does the rail become expandable.
    if (this.isChatCollapsed) {
      if (newWidth >= minWidth) {
        this.isChatCollapsed = false;
        this.headerService.setChatCollapsedState(false);
      } else {
        return; // still within the collapsed zone -> no action
      }
    }

    // Collapse live only on a deliberate LEFT drag into the 55-260 range.
    if (draggingLeft && newWidth < minWidth) {
      this.isResizing = false;
      document.body.classList.remove('rail-resizing');
      this.isChatCollapsed = true;
      this.isContentCollapsed = false;
      this.headerService.setChatCollapsedState(true);
      this.syncVibeLayoutWidth();
      return;
    }

    // Smoothly follow the cursor; clamp only at the hard max so the panel edge
    // stays under the handle the whole time.
    this.chatWidth = Math.min(Math.max(newWidth, this.collapsedChatWidth), maxWidth);
    this.syncVibeLayoutWidth();
  }

  /**
   * Stops resize drag operation
   */
  @HostListener('document:mouseup')
  stopResizing() {
    if (!this.isResizing) {
      return;
    }
    this.isResizing = false;
    document.body.classList.remove('rail-resizing');

    // On release, if the rail was dragged below the minimum expanded width,
    // settle it into the collapsed state; otherwise keep the dragged width.
    if (!this.isChatCollapsed && this.chatWidth < 260) {
      this.isChatCollapsed = true;
      this.isContentCollapsed = false;
      this.headerService.setChatCollapsedState(true);
      this.chatWidth = 420;
    }
    this.syncVibeLayoutWidth();
  }

  /**
   * Global keyboard shortcut handler (Ctrl+K / Cmd+K)
   * @param event - Keyboard event
   */
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
      event.preventDefault();
      if (!this.isSearchDisabled) {
        this.isSearchOverlayOpen = true;
      }
    }
  }

  /**
   * Handle page refresh/close - clear logs
   */
  @HostListener('window:beforeunload')
  onBeforeUnload() {
    this.ngOnDestroy();
  }

  private initializeApplicationContext() {
    const appId = this.route.snapshot.paramMap.get('appId');

    // We only show arrival messages when entering a specific app from the management screen or similar
    if (appId && appId !== 'appId') {
      if (this.currentAppId !== appId) {
        this.currentAppId = appId;

        this.clearChat();

        this.listenToSessionsList();
      }
    }
  }

  initializeDefaults() {
    this.skipStreaming[ChatMessageType.PLAN] = true;
    this.skipStreaming[ChatMessageType.PLAN_OUTLINE] = true;
    this.skipStreaming[ChatMessageType.RECOMMENDATION] = true;
    // why QnA is not here ?

    this.configureListeners();
  }

  configureListeners() {
    this.headerService.createNewSession$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.onCreateNewSession();
    });

    this.headerService.openSessions$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.onOpenSessionPanel();
    });

    this.headerService.toggleChat$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.toggleChat();
    });

    this.headerService.isChatCollapsed$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isCollapsed: boolean) => {
      if (this.isChatCollapsed !== isCollapsed) {
        this.isChatCollapsed = isCollapsed;
        if (this.isChatCollapsed) {
          this.isContentCollapsed = false;
        }
        this.syncVibeLayoutWidth();
      }
    });

    this.headerService.navigateHome$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.ngOnDestroy();
    });

    this.annotationToolService.annotationSent$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (data?.comment) {
        this.chatInput = data.comment;
        // Small delay to allow Angular to detect changes and for potential visual transition if chat box opens
        setTimeout(() => {
          this.onSendMessage();
        }, 300);
      }
    });

    this.appStateService.DataObservables.refreshAppInfo.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (paramsMap: any) => {
        if (!paramsMap.isEmpty) {
          this.handleBetaAccessPrivilegeRevisions();
        }
      }
    });

    this.blueprintStateService.changesetMarkersSubject$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((config: any) => {
        if (config && config.viewMode) {
          this.changesetViewMode = config.viewMode;
        }
      });

    this.store
      .select(metaInfo)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((thatAppmetaInfo: any) => {
        this.appMetaInfo = thatAppmetaInfo;

        this.updateOwnerFilters();
      });
  }

  resetFilters() {
    this.activeFilters.type.clear();
    this.activeFilters.mergeStatus.clear();
    this.activeFilters.owner.clear();
  }

  toggleByType(type: string, event?: any) {
    if (this.activeFilters.type.has(type)) {
      this.activeFilters.type.delete(type);
    } else {
      this.activeFilters.type.add(type);
    }
    event?.stopPropagation();
  }

  toggleByMergeStatus(status: string, event?: any) {
    if (this.activeFilters.mergeStatus.has(status)) {
      this.activeFilters.mergeStatus.delete(status);
    } else {
      this.activeFilters.mergeStatus.add(status);
    }
    event?.stopPropagation();
  }

  toggleByOwner(owner: string, event?: any) {
    if (this.activeFilters.owner.has(owner)) {
      this.activeFilters.owner.delete(owner);
    } else {
      this.activeFilters.owner.add(owner);
    }
    event?.stopPropagation();
  }

  updateOwnerFilters() {
    const ownerMap = new Map<string, string>();

    this.appSessions.forEach((session) => {
      const ownerId = session.modifiedBy || session.createdBy || session.userEmail;

      if (ownerId) {
        const displayName =
          this.appMetaInfo[ownerId] || this.appMetaInfo[session.createdBy] || session.userEmail || ownerId;
        ownerMap.set(ownerId, displayName);
      }
    });

    const colors = [
      { bg: '#e0e7ff', text: '#3b82f6' }, // blue
      { bg: '#dcfce7', text: '#10b981' }, // green
      { bg: '#fef3c7', text: '#f59e0b' }, // yellow
      { bg: '#f3e8ff', text: '#a855f7' }, // purple
      { bg: '#fae8ff', text: '#d946ef' }, // fuchsia
      { bg: '#ffedd5', text: '#ec4899' } // pink
    ];

    const sortedOwners = Array.from(ownerMap.entries()).sort((a, b) => a[1].localeCompare(b[1]));

    this.ownerList = sortedOwners.map(([id, name], index) => {
      return {
        id,
        name: name,
        letter: name.trim().charAt(0).toUpperCase(),
        color: colors[index % colors.length]
      };
    });
  }

  resetConnections() {
    // It is causing that navigation from AppList to AppDetail, due to reset happens :- User moved to Website.. After that, Auto-redirect is again to AppList
    // this.store.dispatch(setUser({ userData: null }));
    // So, removed same from ngOnDestroy() also

    // Clear all streaming intervals
    this.streamingIntervals.forEach((interval) => clearInterval(interval));
    this.streamingIntervals.clear();

    this.unsubscribeFromChat();

    this.sessionListSub?.unsubscribe();
    this.sessionDetailSub?.unsubscribe();
    this.blueprintDetailSub?.unsubscribe();
    this.appDetailSub?.unsubscribe();
  }

  handleBetaAccessPrivilegeRevisions() {
    this.updateIsBetaAccessPrivilegeConsumable();

    if (this.isBetaAccessPrivilegeConsumable) {
      this.initializeApplicationContext();
    } else {
      this.clearChat();
      this.resetConnections();
      this.redirectAwayFromVibePageIfNeeded();
    }
  }

  /**
   * When vibe (RAI) mode is turned off - including from another tab where the change
   * arrives via the userData store listener - the current tab performs no navigation
   * of its own and the user is left stranded on a vibe-only page with a broken layout.
   *
   * This mirrors the VibeRouteGuard fallback so the user is moved off the vibe page:
   * - Inside an app -> the app's requirement documents page.
   * - Outside an app -> the home (app management) page.
   */
  private redirectAwayFromVibePageIfNeeded(): void {
    const orgId = this.route.snapshot.paramMap.get('orgId') || this.appGlobalService.get('orgId') || '';
    const appId = this.route.snapshot.paramMap.get('appId') || this.appGlobalService.get('appId') || '';

    if (!this.isOnVibePage()) {
      return;
    }

    if (appId && appId !== 'appId') {
      this.router.navigate(['/home', orgId, appId, 'gathering', 'documents']);
    } else {
      this.router.navigate(['/home', orgId, 'appId', 'settings', 'appmanagement']);
    }
  }

  /**
   * Determines whether the current route is a vibe-only page that should not remain
   * accessible once vibe (RAI) mode is disabled.
   */
  private isOnVibePage(): boolean {
    const segments = this.router.url
      .split('?')[0]
      .split('#')[0]
      .split('/')
      .filter((segment) => segment.length > 0);
    const homeIndex = segments.indexOf('home');

    if (homeIndex < 0) {
      return false;
    }

    const topLevel = segments[homeIndex + 3] || '';
    const secondLevel = segments[homeIndex + 4] || '';

    // Org-level dashboards are not app-scoped vibe pages, so they must stay accessible.
    if (topLevel === 'dashboards' && ['clouds-centre', 'billing-home'].includes(secondLevel)) {
      return false;
    }

    if (['code', 'operate', 'blueprint', 'dashboards', 'app-dashboards', 'build'].includes(topLevel)) {
      return true;
    }

    if (topLevel === 'prototyping' && secondLevel === 'preview') {
      return true;
    }

    return topLevel === 'settings' && secondLevel === 'environment-availability';
  }

  /**
   * Resumes a session based on the provided session ID.
   * @param sessionId - Selected session ID
   */
  resumeSessionById(sessionId: string) {
    this.isNewSessionActive = false;
    this.headerService.setNewSessionActiveState(false);
    this.isQnACardVisible = false;
    this.isQnADomStateActive = false;

    this.syncSessionsTabWithAvailableOwnedSessions();

    this.sessionId = sessionId;

    // Silently patch the URL to include the session without reloading the app
    const urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams['sessionId'] = this.sessionId;
    this.location.replaceState(this.router.serializeUrl(urlTree));

    this.sessionListSub?.unsubscribe();

    this.fetchSessionMessages();

    this.listenToSessionDetail();
  }

  private listenToSessionDetail() {
    if (!this.sessionId) {
      return;
    }

    this.sessionDetailSub?.unsubscribe();
    this.blueprintDetailSub?.unsubscribe();
    this.appDetailSub?.unsubscribe();

    this.fsBaseService.runAfterFsLogin(() => {
      this.sessionDetailSub = this.fsBaseService
        .fireService({
          collectionName: `AIChatSession_${this.appGlobalService.get('appVersion')}`,
          filter: [{ field: 'sid', operator: '==', value: this.sessionId }]
        })
        .subscribe({
          next: (changes: any[]) => {
            this.processSessionDetail(changes);
          },
          error: (err) => {
            console.error('Failed setup - FSLogin', err);
          }
        });

      this.listenToBPDetail();

      this.listenToAppDetail();
    });
  }

  private listenToBPDetail() {
    this.blueprintDetailSub = this.appStateService.DataMap.Blueprint.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: () => {
        // Default-values - to avoid FOUC
        this.activeBPSession = {
          SystemBP_PC: {
            isEmpty: true
          },
          SystemBP_FD: {
            isEmpty: true
          },
          SessionBP_PC: {
            isEmpty: true
          },
          SessionBP_FD: {
            isEmpty: true
          }
        };

        let dataSourceInfo_SystemBP_PC: any = this.appStateService.getDataSource({
          name: 'SystemBP_PC'
        });

        let dataSourceInfo_SystemBP_FD: any = this.appStateService.getDataSource({
          name: 'SystemBP_FD'
        });

        let dataSourceInfo_SessionBP_PC: any = this.appStateService.getDataSource({
          name: 'SessionBP_PC'
        });

        let dataSourceInfo_SessionBP_FD: any = this.appStateService.getDataSource({
          name: 'SessionBP_FD'
        });

        if (dataSourceInfo_SystemBP_PC?.dataSourceExist && dataSourceInfo_SystemBP_FD?.dataSourceExist) {
          if (dataSourceInfo_SystemBP_PC?.isItemsFilled && dataSourceInfo_SystemBP_FD?.isItemsFilled) {
            this.activeBPSession.SystemBP_PC = dataSourceInfo_SystemBP_PC.data?.[this.currentAppId + '__SYSTEM'];

            this.activeBPSession.SystemBP_FD = dataSourceInfo_SystemBP_FD.data?.[this.currentAppId + '__SYSTEM'];
          }
        }

        if (dataSourceInfo_SessionBP_PC?.dataSourceExist && dataSourceInfo_SessionBP_FD?.dataSourceExist) {
          if (dataSourceInfo_SessionBP_PC?.isItemsFilled && dataSourceInfo_SessionBP_FD?.isItemsFilled) {
            this.activeBPSession.SessionBP_PC =
              dataSourceInfo_SessionBP_PC.data?.[this.currentAppId + '__' + this.sessionId];

            this.activeBPSession.SessionBP_FD =
              dataSourceInfo_SessionBP_FD.data?.[this.currentAppId + '__' + this.sessionId];
          }
        }

        this.changeDetectorRef.detectChanges();
      }
    });
  }

  private listenToAppDetail() {
    this.appDetailSub = this.appStateService.DataMap.App.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        // Default-values - to avoid FOUC
        this.appDetail = {};

        let dataSourceInfo_App: any = this.appStateService.getDataSource({
          name: 'App'
        });

        if (dataSourceInfo_App?.dataSourceExist && dataSourceInfo_App?.isItemsFilled) {
          this.appDetail = dataSourceInfo_App.data?.[this.currentAppId];

          this.changeDetectorRef.detectChanges();
        }
      }
    });
  }

  /**
   * Process stateChanges from Firebase for AppCollection
   * Updates store when prototypingAppUrl is found and unsubscribes.
   */
  private processSessionDetail(changes: any[]) {
    if (!changes || changes.length === 0) {
      return;
    }

    changes.forEach((change) => {
      const doc = change.payload.doc;
      const data = doc.data();

      this.activeSession = {
        ...data
      };

      const loggedInUser = this.appGlobalService.get('userEmail');
      this.activeSession.isOwner =
        !!loggedInUser && !!this.activeSession.userEmail && loggedInUser === this.activeSession.userEmail;

      // request-review
      this.sessionMenuItemsMap.requestReview.disabled = true;
      this.sessionMenuItemsMap.requestReview.visible = this.activeSession.isOwner;

      this.sessionMenuItemsMap.separator_1.visible = this.activeSession.isOwner;

      // rename
      this.sessionMenuItemsMap.rename.visible = this.activeSession.isOwner;

      this.activeSession.summary = this.activeSession.summary || '';

      this.activeSession.mode = this.activeSession.mode || SESSION_MODE.IDEATE;

      this.activeSession.status = this.activeSession.status || SESSION_STATUS.ACTIVE;
      this.activeSession.mergeStatus = this.activeSession.mergeStatus || SESSION_MERGE_STATUS.YET_TO_START;
      this.activeSession.isBuildSessionInitiated = this.activeSession.isBuildSessionInitiated || false;

      // basically, applicable only for mode: "auto"
      this.activeSession.driven = this.activeSession.driven || SESSION_DRIVEN_MODE.MANUAL;

      console.log('active_session: ', this.activeSession);

      // Log the session id to global service
      this.appGlobalService.setSessionId(this.sessionId, this.activeSession);
    });
  }

  /**
   * User clicked on a specific session chip.
   * @param session - Selected session object
   */
  selectSession(session: any) {
    this.sessionSearchQuery = '';
    this.resetFilters();
    this.resumeSessionById(session.sid);
    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');
    this.router.navigate(['/home', orgId, appId, 'blueprint', 'project-charter'], {
      queryParamsHandling: 'preserve'
    });
  }

  /**
   * Fetches available sessions from the server
   */
  private listenToSessionsList(forceShowList = false) {
    this.isLoadingSessions = true;

    this.sessionListSub?.unsubscribe();

    this.sessionListSub = this.appStateService.DataMap.AIChatSession.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: () => {
        this.appSessions = [];

        let dataSourceInfo: any = this.appStateService.getDataSource({
          name: 'AIChatSession'
        });

        if (dataSourceInfo?.dataSourceExist && dataSourceInfo?.isItemsFilled) {
          let processedTuples = dataSourceInfo?.data || [];

          if (processedTuples.length == 0) {
            this.isLoadingSessions = false;
          } else {
            this.appSessions = [];
            const pinnedState: string[] = this.appGlobalService.getLSAppInfo('sessions', 'pinned') || [];

            let hasSelfSessions = false;
            processedTuples.forEach((thatSession: any) => {
              // Check if pinned
              thatSession.isPinned = pinnedState.includes(thatSession.sid);
              thatSession.menuItems = this.buildListMenuItems(thatSession);

              if (thatSession.isOwner) {
                hasSelfSessions = true;
              }

              this.appSessions.push(thatSession);
            });

            if (!hasSelfSessions && this.appSessions.length > 0) {
              this.sessionsTab = 'all';
            }

            this.updateOwnerFilters();
          }

          const urlSessionId = this.route.snapshot.queryParamMap.get('sessionId');

          if (
            !forceShowList &&
            urlSessionId &&
            (this.appSessions.find((s) => s.sid === urlSessionId) || this.appGlobalService.get('appCreated') === true)
          ) {
            this.resumeSessionById(urlSessionId);
          } else {
            this.isSessionsPanelOpen = true;
            this.headerService.setSessionsPanelState(true);
            this.isLoadingSessions = false;
          }

          this.resetAppGlobalFlags();
        }
      }
    });
  }

  /** Pinned Sessions Management */
  isPinnedSessionsCollapsed = false;
  isOtherSessionsCollapsed = false;
  sessionsTab: 'all' | 'self' = 'self';

  isSessionSearchVisible: boolean = false;
  sessionSearchQuery: string = '';

  activeFilters = {
    type: new Set<string>(),
    mergeStatus: new Set<string>(),
    owner: new Set<string>()
  };

  passesSessionFilters(session: any): boolean {
    if (this.activeFilters.type.size > 0) {
      if (
        (this.activeFilters.type.has('ideation') && session.mode === SESSION_MODE.IDEATE) ||
        (this.activeFilters.type.has('build_auto') &&
          session.mode === SESSION_MODE.BUILD &&
          session.driven === SESSION_DRIVEN_MODE.AUTO) ||
        (this.activeFilters.type.has('build_manual') &&
          session.mode === SESSION_MODE.BUILD &&
          session.driven === SESSION_DRIVEN_MODE.MANUAL)
      ) {
        // passed type check
      } else {
        return false;
      }
    }

    if (this.activeFilters.mergeStatus.size > 0) {
      const sessionMergeStatus = session.mergeStatus;
      const hasStatusMatch = Array.from(this.activeFilters.mergeStatus).some((thatMergeStatus) =>
        sessionMergeStatus.includes(thatMergeStatus)
      );
      if (!hasStatusMatch) return false;
    }

    if (this.activeFilters.owner.size > 0) {
      const ownerId = session.modifiedBy || session.createdBy || session.userEmail;
      if (!this.activeFilters.owner.has(ownerId)) {
        return false;
      }
    }

    return true;
  }

  get pinnedSessions() {
    return this.appSessions.filter((s) => s.isPinned && this.passesSessionFilters(s));
  }

  get displayedSessions() {
    return this.appSessions.filter((s) => {
      let matchesTab = true;
      if (this.sessionsTab === 'self') {
        matchesTab = s.isOwner;
      }
      return matchesTab && this.passesSessionFilters(s);
    });
  }

  get searchResultsSessions() {
    if (!this.sessionSearchQuery || this.sessionSearchQuery.trim().length === 0) return [];

    const lowerQuery = this.sessionSearchQuery.trim().toLowerCase();

    return this.appSessions.filter((s) => {
      const matchesSearch = s.sessionName && s.sessionName.toLowerCase().includes(lowerQuery);
      if (!matchesSearch) return false;

      const matchesTab = this.sessionsTab === 'all' || s.isOwner;
      const validBoundary = s.isPinned || matchesTab;

      return validBoundary && this.passesSessionFilters(s);
    });
  }

  setSessionsTab(tab: 'all' | 'self') {
    this.sessionsTab = tab;
  }

  private syncSessionsTabWithAvailableOwnedSessions(): void {
    const hasSelfSessions = this.appSessions.some((session) => session.isOwner);

    if (!hasSelfSessions && this.appSessions.length > 0) {
      this.sessionsTab = 'all';
    }
  }

  toggleSessionPin(session: any) {
    session.isPinned = !session.isPinned;

    let pinnedState: string[] = this.appGlobalService.getLSAppInfo('sessions', 'pinned') || [];

    if (session.isPinned) {
      if (!pinnedState.includes(session.sid)) {
        pinnedState.push(session.sid);
      }
    } else {
      pinnedState = pinnedState.filter((id) => id !== session.sid);
    }

    this.appGlobalService.saveLSAppInfo('sessions', 'pinned', pinnedState);

    // Update menu items specifically for this session to reflect correct pin/unpin text
    session.menuItems = this.buildListMenuItems(session);
  }

  constructSessionMenuItems() {
    /** Menu items for session options (kebab menu) */

    /*
        PIN Is removed intentionally in session-detail, as it is not managable

        Session-list component and it's source(appSessions) are not maintained in BE.. those will be destroyed upon switch btw list n detail
    */

    const _this = this;

    this.sessionMenuItemsMap = {
      reject: {
        label: this.translate.instant('DISCARD') || 'Discard',
        icon: 'pi pi-times',
        command: () => {
          this.onRejectSession();
        },
        get visible() {
          return (
            _this.appDetail?.mergeStatus !== _this.SESSION_MERGE_STATUS.IN_PROGRESS &&
            _this.activeSession?.isOwner &&
            _this.activeSession?.mode === _this.SESSION_MODE.IDEATE &&
            (_this.activeSession?.mergeStatus === _this.SESSION_MERGE_STATUS.YET_TO_START ||
              _this.activeSession?.mergeStatus === _this.SESSION_MERGE_STATUS.FAILED) &&
            !(_this.activeBPSession?.SessionBP_PC?.isEmpty && _this.activeBPSession?.SessionBP_FD?.isEmpty)
          );
        },
        get disabled() {
          return _this.isSessionConfirmationPending || _this.Flags.isSessionActionsDisabled;
        }
      },
      requestReview: {
        label: 'Request Review',
        icon: 'pi pi-users',

        command: () => {
          console.log('Future scope');
        }
      },
      separator_1: {
        separator: true
      },
      rename: {
        label: this.translate.instant('RENAME'),
        icon: 'pi pi-pencil',

        command: () => {
          this.openRenameSessionDialog(this.activeSession);
        }
      }
    };

    this.sessionMenuItems = [
      this.sessionMenuItemsMap.reject,
      this.sessionMenuItemsMap.requestReview,
      this.sessionMenuItemsMap.separator_1,
      this.sessionMenuItemsMap.rename,
      {
        label: this.translate.instant('COPY_LINK'),
        icon: 'pi pi-copy',
        command: () => {
          const url = globalThis.window.location.href;
          globalThis.navigator.clipboard.writeText(url).then(() => {
            this.utilService.showMessage('success', this.translate.instant('LINK_COPIED_TO_CLIPBOARD'));
          });
        }
      },
      {
        label: this.translate.instant('SEND_MAIL'),
        icon: 'pi pi-envelope',
        command: () => {
          const sessionUrl = globalThis.window.location.href;
          this.openShareSessionDialog(sessionUrl);
        }
      }
    ];
  }

  buildListMenuItems(session: any): MenuItem[] {
    return [
      {
        label: session.isPinned ? this.translate.instant('UNPIN') : this.translate.instant('PIN'),
        icon: session.isPinned ? 'pi pi-star-fill' : 'pi pi-star',
        command: () => {
          this.toggleSessionPin(session);
        }
      },
      {
        label: this.translate.instant('RENAME'),
        icon: 'pi pi-pencil',
        visible: session.isOwner,
        command: () => {
          this.openRenameSessionDialog(session);
        }
      },
      {
        label: this.translate.instant('COPY_LINK'),
        icon: 'pi pi-copy',
        command: () => {
          const urlTree = this.router.parseUrl(this.router.url);
          urlTree.queryParams['sessionId'] = session.sid;
          const url =
            globalThis.window.location.origin + this.location.prepareExternalUrl(this.router.serializeUrl(urlTree));

          globalThis.navigator.clipboard.writeText(url).then(() => {
            this.utilService.showMessage('success', this.translate.instant('LINK_COPIED_TO_CLIPBOARD'));
          });
        }
      },
      {
        label: this.translate.instant('SEND_MAIL'),
        icon: 'pi pi-envelope',
        command: () => {
          const urlTree = this.router.parseUrl(this.router.url);
          urlTree.queryParams['sessionId'] = session.sid;
          const url =
            globalThis.window.location.origin + this.location.prepareExternalUrl(this.router.serializeUrl(urlTree));

          this.openShareSessionDialog(url);
        }
      }
    ];
  }

  onChatScroll(event: Event) {
    const container = event.target as HTMLElement;
    // Load more when we reach close to the top
    if (container.scrollTop <= 200 && this.hasMoreHistory && !this.isLoadingHistory && !this.isLoadingSessions) {
      this.fetchSessionMessages(true);
    }
  }

  /**
   * Resumes a specific session from history
   * @param isLoadMore - indicates if this is a pagination fetch
   */
  fetchSessionMessages(isLoadMore = false) {
    let endpoint = ApiConstants.sessionMessages;

    if (!isLoadMore) {
      this.messages = [];
      this.hasMoreHistory = true;
      this.historyCursor = null;

      const ChatEventsConfig: any = {};
      this.listenToChatEvents(ChatEventsConfig);

      this.isSessionsPanelOpen = false;
      this.headerService.setSessionsPanelState(false);
      this.isLoadingSessions = true;
    } else {
      this.isLoadingHistory = true;
    }

    const payload: any = {
      sessionId: this.sessionId,
      queryParams: {
        limit: this.CONVERSATION_FETCH_LIMIT
      }
    };
    if (this.historyCursor) {
      payload.queryParams.cursor = this.historyCursor;
    }

    this.httpBaseService[endpoint.method](endpoint, payload)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response?.isInvalidSession) {
            console.error('session ID is invalid or has expired:', this.sessionId);
            this.clearChat(); // Use to reset everything (maps, messages, subs)
            this.isLoadingSessions = false;
            this.isLoadingHistory = false;
            return;
          }

          let useProxyFlow = false;

          if (useProxyFlow) {
            response.conversations = [
              {
                sid: 'mock-conversation-c1',
                messages: [],
                status: ChatMessageStatus.PENDING
              }
            ];
          }

          if (response?.conversations?.length) {
            let oldestConvDate: Date | null = null;

            // Sort conversations by their sequence to maintain strict chronological grouping
            response.conversations.sort((a: any, b: any) => (a.sequence || 0) - (b.sequence || 0));

            // Populate the firestoreMessagesMap with historical messages
            // This ensures that subsequent real-time updates from Firebase
            // merge with or correctly overwrite historical data.
            response.conversations.forEach((thatConversation: any) => {
              if (thatConversation.messages) {
                thatConversation.messages.forEach((msg: any) => {
                  const id = msg.sid;
                  if (id) {
                    this.firestoreMessagesMap.set(id, { ...msg, id });
                  }
                });
              }

              const currentConvDate = new Date(thatConversation.createdDate);
              if (!oldestConvDate || currentConvDate < oldestConvDate) {
                oldestConvDate = currentConvDate;
              }
            });

            if (oldestConvDate) {
              this.historyCursor = (oldestConvDate as any).toISOString();
            }

            // Rebuild the final sorted message array from history + any real-time events
            // This is history load, so we explicitly skip streaming animations
            //
            // ARCHITECTURAL NOTE: We intentionally removed programmatic/manual container.scrollTop
            // mathematical adjustments here. Because our Angular trackBy perfectly preserves the
            // existing DOM nodes, we rely entirely on the browser's native `overflow-anchor: auto`
            // implementation. This gives butter-smooth history prepends and completely eliminates
            // the 2-3 line layout jerk caused by JS sub-pixel scroll-height conflicts.
            this.updateChatMessages(Array.from(this.firestoreMessagesMap.values()), { skipStreaming: true });
          } else {
            this.hasMoreHistory = false;
          }

          this.isLoadingSessions = false;
          this.isLoadingHistory = false;
        },
        error: (error) => {
          this.isLoadingSessions = false;
          this.isLoadingHistory = false;
          console.error('main-layout.component.ts: fetch_MessagesForSession - error', error);
          this.clearChat();
          this.utilService.showMessage('error', this.translate.instant('INVALID_SESSION_ID'));
        }
      });
  }

  /**
   * Clears the chat history and resets the flow
   */
  clearChat() {
    this.unsubscribeFromChat();

    this.messages = [];
    this.appGlobalService.setChatPending(false);
    this.resetChangeMode();
    this.changeRequestMessageIndex = null;

    this.activeFlow = 'none';
    this.sessionId = '';
    this.appGlobalService.setSessionId('');
    this.activeSession = {};
    this.activeBPSession = {};

    this.isChatDisabled = true;

    // Silently drop the sessionId from the URL
    const urlTree = this.router.parseUrl(this.router.url);
    if (urlTree.queryParams['sessionId']) {
      delete urlTree.queryParams['sessionId'];
      this.location.replaceState(this.router.serializeUrl(urlTree));
    }

    setTimeout(() => {
      if (this.chatTextarea?.nativeElement) {
        this.chatTextarea.nativeElement.style.height = this.promptboxHeight;
      }
    }, 0);
  }

  /**
   * Helper to execute a callback only after Firestore login is confirmed.
   */

  private resetChatStateAndExpand() {
    this.isSessionConfirmationPending = false;
    this.clearChat();

    // Close available sessions box instead of wiping metadata array
    this.isSessionsPanelOpen = false;
    this.headerService.setSessionsPanelState(false);

    // Also, if collapsed, expand
    if (this.isChatCollapsed) {
      this.isChatCollapsed = false;
      this.headerService.setChatCollapsedState(this.isChatCollapsed);
    }

    // clear queues / streaming intervals - ignore async responses
    this.messageQueue.length = 0;
    this.streamingIntervals.forEach((intervalId) => clearInterval(intervalId));
    this.streamingIntervals.clear();

    // Clear user type string
    this.chatInput = '';
    this.chatboxMode = null;

    // Focus cursor on chatbox
    setTimeout(() => {
      if (this.chatTextarea?.nativeElement) {
        this.chatTextarea.nativeElement.style.height = this.promptboxHeight;
      }
    }, 0);
  }

  /**
   * Initializes a new session by clearing current tracking variables
   * and resetting the ui to pristine state to start over
   */
  onCreateNewSession(): void {
    this.isSessionConfirmationPending = false;

    this.isNewSessionActive = true;
    this.isSessionSummaryExpanded = false;
    this.headerService.setNewSessionActiveState(true);
    this.blueprintStateService.setChangesetMarkers({});
    this.isQnACardVisible = false;
    this.isQnADomStateActive = false;

    this.sessionId = '';
    this.appGlobalService.setSessionId('');

    // Remove sessionId from URL silently
    const urlTree = this.router.parseUrl(this.router.url);
    delete urlTree.queryParams['sessionId'];
    this.location.replaceState(this.router.serializeUrl(urlTree));

    this.resetChatStateAndExpand();

    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');
    this.router.navigate(['/home', orgId, appId, 'blueprint', 'project-charter'], {
      queryParamsHandling: 'preserve'
    });

    setTimeout(() => {
      if (this.chatTextarea?.nativeElement) {
        this.chatTextarea.nativeElement.focus();
      }
    }, 1);

    this.chatboxMode = 'ideate';
    this.activeSession.status = SESSION_STATUS.ACTIVE;

    // Force enable chat so they can type
    this.isChatDisabled = false;
  }

  onLogoClick(): void {
    this.navigateToHome();
  }

  private navigateToHome(): void {
    this.headerService.triggerNavigateHome();
    this.appGlobalService.clearAppInfo();
    this.headerService.setChatCollapsedState(false);

    const orgId = this.appGlobalService.get('orgId');
    if (orgId) {
      this.router.navigate(['/home', orgId, 'appId', 'settings', 'appmanagement']);
    }
  }

  /**
   * Listen to Firebase stateChanges for AIChatMessage and AIChatConversation
   * Filtered by appId and sessionId
   */
  private listenToChatEvents(config: any) {
    this.unsubscribeFromChat();

    let listenToChatEventsProxy = (config: any) => {
      this.processMessageList(
        this.wrapInFirebaseFormat([
          getMockMessagePayload('PLAN_OUTLINE_V2'),
          getMockMessagePayload('SHIMMER_1'),
          getMockMessagePayload('SHIMMER_2')
        ])
      );
    };

    const appId = this.appGlobalService.get('appId');
    if (!appId || !this.sessionId) {
      return;
    }

    if (!config.currentTS) {
      config.currentTS = new Date(Date.now() - 10000);
    }

    let useProxyFlow = false;

    if (useProxyFlow) {
      config.appId = appId;
      listenToChatEventsProxy(config);
    } else {
      this.fsBaseService.runAfterFsLogin(() => {
        // Listen to AIChatConversation
        this.conversationSub = this.fsBaseService
          .fireService({
            collectionName: `AIChatConversation_${this.appGlobalService.get('appVersion')}`,
            filter: [
              { field: 'appId', operator: '==', value: appId },
              { field: 'sessionId', operator: '==', value: this.sessionId }
            ]
          })
          .subscribe({
            next: (changes: any[]) => {
              this.processConversationList(changes);
            },
            error: (err) => {
              console.error('Failed to setup listener for conversation', err);
            }
          });

        // Listen to AIChatMessage
        this.messageSub = this.fsBaseService
          .fireService({
            collectionName: `AIChatMessage_${this.appGlobalService.get('appVersion')}`,
            filter: [
              { field: 'appId', operator: '==', value: appId },
              { field: 'sessionId', operator: '==', value: this.sessionId },
              { field: 'modifiedDate', operator: '>=', value: config.currentTS }
            ]
          })
          .subscribe({
            next: (changes: any[]) => {
              this.processMessageList(changes);
            },
            error: (err) => {
              console.error('main-layout.component.ts: listen_ToChatEvents (message) - error', err);
            }
          });
      });
    }
  }

  /**
   * Filter tree nodes by type (datamodel or page)
   */
  getFilteredNodes(nodes: TreeNode[] | undefined, type: string): TreeNode[] {
    if (!nodes) {
      return [];
    }
    return nodes.filter((n) => n.data.itemType === type);
  }

  /**
   * Utility to wrap raw proxy backend data into the standard Firebase stateChanges format
   * @param data - Raw data or array of data from proxy
   */
  private wrapInFirebaseFormat(data: any): any[] {
    const items = Array.isArray(data) ? data : [data];
    return items.map((item) => ({
      type: 'added',
      payload: {
        doc: {
          id: item.sid,
          data: () => item
        }
      }
    }));
  }

  /**
   * Process stateChanges from Firebase for AIChatConversation
   * Checks if all conversation documents are marked as 'completed'
   */
  private processConversationList(changes: any[]) {
    if (!changes || changes.length === 0) {
      return;
    }

    changes.forEach((change) => {
      const doc = change.payload.doc;
      const data = doc.data();
      const id = data.sid;

      if (change.type === 'removed') {
        this.firestoreConversationMap.delete(id);
      } else {
        // added or modified
        this.firestoreConversationMap.set(id, { ...data, id });
      }
    });

    this.changeDetectorRef.detectChanges();
  }

  /**
   * Process stateChanges from Firebase for AIChatMessage
   * Maintains a local map of documents and updates the UI
   */
  private processMessageList(changes: any[]) {
    if (!changes || changes.length === 0) {
      return;
    }
    this.isLoadingSessions = false;

    changes.forEach((change) => {
      const doc = change.payload.doc;
      const data = doc.data();
      const id = data.sid;

      // Convert Firebase Timestamps to JS Date objects for consistency with REST API
      ['createdDate'].forEach((field) => {
        if (data[field]) {
          data[field] = this.utilService.getJsDateFromTimestamp(data[field]);
        }
      });

      if (change.type === 'removed') {
        this.firestoreMessagesMap.delete(id);
      } else {
        // added or modified
        this.firestoreMessagesMap.set(id, { ...data, id });
      }
    });

    const rawMessages = Array.from(this.firestoreMessagesMap.values());
    this.updateChatMessages(rawMessages);
  }

  /**
   * Wrapper function to process raw AIChatMessage documents
   * and update the UI messages array
   */
  trackByMessage(index: number, item: ChatMessage): string {
    return item.sid || index.toString();
  }

  private updateChatMessages(fsMessages: any[], options: { skipStreaming?: boolean } = {}) {
    if (!fsMessages || fsMessages.length === 0) {
      this.messages = [];
      this.appGlobalService.setChatPending(false);
      return;
    }

    // Sort by createdDate (oldest first). If same date, fallback to sequence to maintain strict chronological order
    const sortedRaw = [...fsMessages].sort((a, b) => {
      const dateA = a.createdDate ? new Date(a.createdDate).getTime() : 0;
      const dateB = b.createdDate ? new Date(b.createdDate).getTime() : 0;

      if (dateA === dateB) {
        return (a.sequence || 0) - (b.sequence || 0);
      }

      return dateA - dateB;
    });

    // Map old messages by ID for fast lookup to preserve object transitions
    const oldMessagesMap = new Map<string, ChatMessage>();
    this.messages.forEach((msg) => {
      if (msg.sid) {
        oldMessagesMap.set(msg.sid, msg);
      }
    });

    this.messages = sortedRaw.map((msg, index) => {
      const isUser = msg.role === 'user';
      const isLast = index === sortedRaw.length - 1;

      // Ensure Q&A stringified content is fully unpacked
      if (
        msg.content &&
        (msg.messageType === ChatMessageType.QUESTION_AND_ANSWERS || msg.messageType === ChatMessageType.RECOMMENDATION)
      ) {
        let parsedContent: any = msg.content;
        if (typeof msg.content === 'string' && msg.content.trim().startsWith('{')) {
          try {
            parsedContent = JSON.parse(msg.content);
          } catch (e) {
            console.warn('Failed to parse QnA content JSON', e);
            parsedContent = {};
          }
        }
        if (parsedContent && typeof parsedContent === 'object') {
          msg.content = parsedContent;
        }
      }

      let targetText = msg.htmlText || msg.content || msg.text || '';
      targetText = this.extractContentText(targetText);

      // Only format multi-line responses for standard agent responses
      if (
        !isUser &&
        !msg.htmlText &&
        msg.messageType?.toLowerCase() === ChatMessageType.AGENT_RESPONSE &&
        targetText?.includes('\n')
      ) {
        targetText = targetText
          .split('\n')
          .map((line: string) => `<div class="assistant-response-multi-lines">${line}</div>`)
          .join('');
        msg.renderAsHtml = true;
      }

      const oldMsg = oldMessagesMap.get(msg.sid);

      // Determine if streaming is allowed:
      // 1. Must be an assistant message with text
      // 2. Must be the last message in current response stream
      // 3. Must NOT be an initial load from history (options.skipStreaming)
      let shouldStream = !isUser && targetText && isLast && !options.skipStreaming;

      if (msg.htmlText) {
        shouldStream = false;
        msg.renderAsHtml = true;
      }

      if (msg?.override_shouldStream !== undefined) {
        shouldStream = msg.override_shouldStream;
      }

      let chatMsg = oldMsg;

      if (!chatMsg) {
        // NEW ARRIVAL: Only stream if it's the last assistant message AND allowed
        chatMsg = {
          sid: msg.sid,
          type: isUser ? 'user' : 'assistant',
          text: targetText,
          displayedText: shouldStream ? '' : targetText,
          isStreaming: shouldStream
        };
      }

      const prevText = chatMsg.text;

      // Sync metadata - forward properties directly to avoid manual mapping
      Object.assign(chatMsg, msg);

      // Restore normalized text which handles streaming logic and fallback
      chatMsg.text = targetText;

      // Ensure displayed text is instantly fully rendered when streaming is skipped (like for htmlText)
      if (!shouldStream) {
        chatMsg.displayedText = targetText;
      }

      // Predict if message actions should be visible
      if (isUser) {
        chatMsg.showServerMessageOptions = true;
      } else {
        if (
          chatMsg.messageType === ChatMessageType.PLAN ||
          chatMsg.messageType === ChatMessageType.PLAN_OUTLINE ||
          chatMsg.messageType === ChatMessageType.SHIMMER ||
          ((chatMsg.messageType === ChatMessageType.QUESTION_AND_ANSWERS ||
            chatMsg.messageType === ChatMessageType.RECOMMENDATION) &&
            chatMsg.status !== ChatMessageStatus.COMPLETED) ||
          !chatMsg.text
        ) {
          chatMsg.showServerMessageOptions = false;
        } else {
          chatMsg.showServerMessageOptions = true;
        }
      }

      if (!oldMsg) {
        const messageType = chatMsg.messageType;
        if (shouldStream && messageType && !this.skipStreaming[messageType]) {
          this.startStreaming(chatMsg);
        }
      } else if (prevText !== targetText) {
        // EXISTING MESSAGE: Check for text changes (Live update)
        // Only re-stream if it's the latest message AND allowed
        if (shouldStream) {
          chatMsg.isStreaming = true;
          const messageType = chatMsg.messageType;
          if (messageType && !this.skipStreaming[messageType]) {
            this.startStreaming(chatMsg);
          }
        } else {
          // Otherwise just update instantly
          chatMsg.displayedText = targetText;
          chatMsg.isStreaming = false;
        }
      }

      // Ensure actions are parsed if stringified
      if (typeof chatMsg.actions === 'string') {
        try {
          chatMsg.actions = JSON.parse(chatMsg.actions);
        } catch (e) {
          console.warn('Failed to parse actions JSON', e);
        }
      }

      // Format Q&A answers dynamically by pairing backward-fetched questions with the raw answers
      if (
        chatMsg.messageType === ChatMessageType.QUESTION_AND_ANSWERS &&
        chatMsg.status === ChatMessageStatus.COMPLETED
      ) {
        const questions = chatMsg.content?.questions;
        if (questions) {
          chatMsg.content = this.formatQAAnswers(questions, chatMsg.content);
        }
        chatMsg.isCollapsed = true;
      }

      // Extract icon-buttons from actions (e.g. Reject, Delete, etc.)
      const isActionInProgress = chatMsg.isActionInProgress || false;
      const iconActions = chatMsg.actions?.filter((a: ChatAction) => a.renderAsIcon === 'true');

      if (iconActions && iconActions.length > 0) {
        chatMsg.iconActions = iconActions.map((a: ChatAction) => ({
          ...a,
          disabled: isActionInProgress
        }));
      } else {
        chatMsg.iconActions = [];
      }

      const leftActions = chatMsg.actions?.filter((a: ChatAction) => a.align === 'left' && a.renderAsIcon !== 'true');
      const rightActions = chatMsg.actions?.filter((a: ChatAction) => a.align !== 'left' && a.renderAsIcon !== 'true');

      if (leftActions && leftActions.length > 0) {
        chatMsg.leftActions = leftActions.map((a: ChatAction) => ({
          ...a,
          isPrimary: a.code === msg.primaryAction,
          disabled: isActionInProgress
        }));
      } else {
        chatMsg.leftActions = [];
      }

      if (rightActions && rightActions.length > 0) {
        chatMsg.rightActions = rightActions.map((a: ChatAction) => ({
          ...a,
          isPrimary: a.code === msg.primaryAction,
          disabled: isActionInProgress
        }));
      } else {
        chatMsg.rightActions = [];
      }

      // Remove original generic actions array once distributed as left and right
      delete chatMsg.actions;

      // Extract label from content if available
      if (msg.messageType === ChatMessageType.SHIMMER && (msg.content || msg.text)) {
        try {
          const contentToParse = msg.content || msg.text; // Prefer content, fallback to text
          if (contentToParse) {
            if (typeof contentToParse === 'string' && contentToParse.trim().startsWith('{')) {
              const parsed = JSON.parse(contentToParse);
              chatMsg.label = parsed.label || parsed.data?.label || parsed.text;
            } else if (typeof contentToParse === 'object') {
              chatMsg.label = contentToParse.label || contentToParse.data?.label || contentToParse.text;
            }
          }
        } catch (e) {
          // Fallback to text if parsing fails
          console.warn('Failed to parse shimmer content for label', e);
        }
      }

      if (chatMsg.status === ChatMessageStatus.COMPLETED && chatMsg.messageType === ChatMessageType.PLAN) {
        chatMsg.isCollapsed = true;
      }

      // Map complex objects for assistant messages
      if (!isUser) {
        if (msg.treeTableData) {
          chatMsg.treeTableData = msg.treeTableData;
        }

        if (chatMsg.messageType === ChatMessageType.PLAN && (msg.content || msg.text)) {
          try {
            const contentToParse = msg.content || msg.text;
            if (typeof contentToParse === 'string' && contentToParse.trim().startsWith('{')) {
              chatMsg.plan = JSON.parse(contentToParse);
            }

            // Handle artifacts

            const planData = chatMsg.plan as PlanStructure;

            const tableCards: any[] = [];
            if (planData?.artifacts?.datamodel?.create) {
              const datamodelCards = planData.artifacts.datamodel.create.map((t: any) => {
                const addArray = Array.isArray(t.payload.tableFields)
                  ? t.payload.tableFields
                  : t.payload.tableFields?.add || [];

                return {
                  tableName: t.payload.name || t.targetId,
                  type: 'datamodel',
                  isUpdate: false,
                  fields: addArray.map((f: any) => ({
                    name: f.fieldName,
                    type: mapSqlTypeToUiType(f.fieldType),
                    isNew: true
                  }))
                };
              });
              tableCards.push(...datamodelCards);
            }

            if (planData?.artifacts?.datamodel?.update) {
              const datamodelUpdateCards = planData.artifacts.datamodel.update.map((t: any) => {
                // Determine added fields
                const addArray = Array.isArray(t.payload?.tableFields)
                  ? t.payload.tableFields
                  : t.payload?.tableFields?.add || [];

                const addedFields = addArray.map((f: any) => ({
                  name: f.fieldName,
                  type: mapSqlTypeToUiType(f.fieldType),
                  isNew: true
                }));

                // Determine changed fields
                const changedFields = t.payload?.tableFields?.update
                  ? t.payload.tableFields.update.map((f: any) => ({
                      name: f.changes?.fieldName || f.fieldName,
                      oldName: f.changes?.fieldName ? f.fieldName : undefined,
                      type: mapSqlTypeToUiType(f.changes?.fieldType || f.fieldType),
                      isNew: false
                    }))
                  : [];

                // Determine deleted fields
                const deletedFields = t.payload?.tableFields?.delete
                  ? t.payload.tableFields.delete.map((f: any) => {
                      return {
                        name: f,
                        type: 'Unknown', // Type might not be known if passing only string names
                        isNew: false,
                        isDelete: true
                      };
                    })
                  : [];

                const allAddedOrChangedFields = [...addedFields, ...changedFields, ...deletedFields];

                const newTableName = t.payload?.changes?.tableName;
                const oldTableName = t.targetId;
                const isOnlyDelete = deletedFields.length > 0 && addedFields.length === 0 && changedFields.length === 0;

                return {
                  tableName: newTableName || oldTableName,
                  oldTableName: newTableName ? oldTableName : undefined,
                  type: 'datamodel',
                  isUpdate: true,
                  isOnlyDelete: isOnlyDelete,
                  hasAdd: addedFields.length > 0,
                  hasEdit: changedFields.length > 0,
                  hasDelete: deletedFields.length > 0,
                  fields: allAddedOrChangedFields
                };
              });
              tableCards.push(...datamodelUpdateCards);
            }

            if (planData?.artifacts?.datamodel?.delete) {
              const datamodelDeleteCards = planData.artifacts.datamodel.delete.map((tName: string) => {
                return {
                  tableName: tName,
                  type: 'datamodel',
                  isUpdate: true,
                  isOnlyDelete: true,
                  isTableDelete: true,
                  hasAdd: false,
                  hasEdit: false,
                  hasDelete: true,
                  fields: []
                };
              });
              tableCards.push(...datamodelDeleteCards);
            }

            if (planData?.artifacts?.page?.create) {
              const pageCards = planData.artifacts.page.create.map((p: any) => ({
                tableName: `${p.payload?.screenName} (${p.payload?.screenType})`,
                type: 'page'
              }));
              tableCards.push(...pageCards);
            }

            if (tableCards.length > 0) {
              const { treeData } = this.buildTreeTableData(tableCards);
              chatMsg.tableCards = tableCards;
              chatMsg.treeTableData = treeData;
            }
          } catch (e) {
            console.error('Error parsing plan content', e);
          }
        }

        if (chatMsg.messageType === ChatMessageType.PLAN_OUTLINE && msg.content) {
          try {
            const contentToParse = msg.content;
            if (typeof contentToParse === 'string' && contentToParse.trim().startsWith('{')) {
              chatMsg.content = JSON.parse(contentToParse);
            }
          } catch (e) {
            console.error('Error parsing plan content', e);
          }
        }

        if (msg.tableCards) {
          // Rebuild tree table data ONLY if they changed to prevent visual flickers/resets
          const currentJson = JSON.stringify(msg.tableCards);
          const oldJson = JSON.stringify(chatMsg.tableCards);

          if (currentJson !== oldJson) {
            const { treeData } = this.buildTreeTableData(msg.tableCards);
            chatMsg.tableCards = msg.tableCards;
            chatMsg.treeTableData = treeData;
          }
        }
      }

      return chatMsg;
    });

    // Grouping logic for Shimmer messages
    // Sequential shimmer messages are grouped under the latest one in that sequence
    const finalMessages: ChatMessage[] = [];
    let tempShimmerGroup: ChatMessage[] = [];

    for (let i = 0; i < this.messages.length; i++) {
      const m = this.messages[i];
      const nextM = this.messages[i + 1];

      if (m.messageType === ChatMessageType.SHIMMER) {
        // Ensure every individual shimmer message is parsed so we have labels/icons for the timeline
        m.latestShimmerLabel = m.text || '';
        m.latestShimmerIcon = 'search-md';
        m.latestShimmerTitle = this.translate.instant('ANALYSIS_COMPLETED');

        try {
          const contentToParse = m.content || m.text;
          if (contentToParse && typeof contentToParse === 'string' && contentToParse.trim().startsWith('{')) {
            const parsed = JSON.parse(contentToParse);
            m.latestShimmerLabel = parsed.label || parsed.data?.label || parsed.text || m.text;
            m.latestShimmerIcon = parsed.icon || parsed.data?.icon || 'search-md';
            m.latestShimmerTitle = parsed.title || parsed.data?.title || m.latestShimmerTitle;
          } else if (contentToParse && typeof contentToParse === 'object') {
            m.latestShimmerLabel = contentToParse.label || contentToParse.data?.label || contentToParse.text || m.text;
            m.latestShimmerIcon = contentToParse.icon || contentToParse.data?.icon || 'search-md';
            m.latestShimmerTitle = contentToParse.title || contentToParse.data?.title || m.latestShimmerTitle;
          } else {
            m.latestShimmerLabel = m.text;
          }
        } catch (e) {
          console.warn('Failed to parse shimmer content for latestShimmerLabel', e);
          m.latestShimmerLabel = m.text;
        }

        if (nextM?.messageType === ChatMessageType.SHIMMER) {
          // Check if any message in the sequence (including precursors) was user-toggled
          // and carry that state forward to the next message in the sequence
          if (m.userToggled) {
            nextM.userToggled = true;
            nextM.isCollapsed = m.isCollapsed;
          }
          // It's not the last shimmer in a sequence, so group it
          m.isGrouped = true;
          tempShimmerGroup.push(m);
        } else {
          // It's the last shimmer in a sequence (the "header")
          m.isGrouped = false;

          // If a non-shimmer message follows, mark this shimmer sequence as completed
          if (nextM && nextM.messageType !== ChatMessageType.SHIMMER) {
            m.status = 'completed';
          } else {
            // volunteerly, ovewriting [shimmer]msg-object
            m.status = 'pending';
          }

          m.shimmerGroup = [...tempShimmerGroup, m];

          // If the final header message has been toggled (carried over from previous shimmers), respect it
          if (m.userToggled && m.isCollapsed !== undefined) {
            // Keep existing collapsed state set by toggleCollapse
          } else if (m.status === ChatMessageStatus.COMPLETED) {
            m.isCollapsed = true; // Auto-collapse when done
          } else {
            m.isCollapsed = false; // By default shimmers should be open
          }

          tempShimmerGroup = []; // Reset for next potential sequence
          finalMessages.push(m);
        }
      } else {
        // Not a shimmer message
        finalMessages.push(m);
        tempShimmerGroup = []; // Just in case
      }
    }

    // Safety: ensure trailing shimmers aren't dropped if loop ends
    if (tempShimmerGroup.length > 0 && !finalMessages.includes(this.messages[this.messages.length - 1])) {
      // This shouldn't normally happen with the current logic but good for debugging
    }

    this.messages = finalMessages;

    // Compute elapsed time and speedometer flags for static rendering
    for (let i = 0; i < this.messages.length; i++) {
      const msg = this.messages[i];
      if (msg.type !== 'user') {
        let isLastVisibleActionMsg = true;

        if (msg.showServerMessageOptions === false) {
          isLastVisibleActionMsg = false;
        } else {
          for (let j = i + 1; j < this.messages.length; j++) {
            const nextMsg = this.messages[j];
            if (nextMsg.type === 'user') {
              break;
            }
            if (nextMsg.showServerMessageOptions !== false) {
              isLastVisibleActionMsg = false;
              break;
            }
          }
        }

        msg.showSpeedometer = isLastVisibleActionMsg;

        if (msg.elapsedTimeString === undefined) {
          let prevUserMsg: any = null;
          for (let j = i - 1; j >= 0; j--) {
            if (this.messages[j]?.type === 'user') {
              prevUserMsg = this.messages[j];
              break;
            }
          }
          if (prevUserMsg?.createdDate && msg.createdDate) {
            const start = new Date(prevUserMsg.createdDate).getTime();
            const end = new Date(msg.createdDate).getTime();
            const diffInSeconds = Math.floor((end - start) / 1000);
            if (diffInSeconds >= 0 && !Number.isNaN(diffInSeconds)) {
              msg.elapsedTimeString =
                diffInSeconds < 60 ? `${diffInSeconds}s • ` : `${Math.floor(diffInSeconds / 60)}m • `;
            } else {
              msg.elapsedTimeString = '';
            }
          } else {
            msg.elapsedTimeString = '';
          }
        }

        if (msg.showSpeedometer) {
          let tooltipString = msg.elapsedTimeString || '';

          const thatConversation = msg.conversationId ? this.firestoreConversationMap.get(msg.conversationId) : null;

          if (thatConversation) {
            const displayCredits = thatConversation.creditsUsed ? Number(thatConversation.creditsUsed).toFixed(3) : 0;
            const rawTokens = thatConversation.tokensUsed || 0;
            const displayTokens = rawTokens >= 1000 ? (rawTokens / 1000).toFixed(0) + 'K' : rawTokens;
            tooltipString += `${displayCredits} ${this.translate.instant('CREDITS_USED')} • ${displayTokens} ${this.translate.instant('TOKENS_USED')}`;
          } else if (tooltipString.endsWith(' • ')) {
            tooltipString = tooltipString.substring(0, tooltipString.length - 3);
          }

          msg.speedometerTooltip = tooltipString;
        }
      }
    }

    if (this.messages.length > 0) {
      const lastMsg = this.messages[this.messages.length - 1];

      if (lastMsg) {
        let latestPendingPlanMsg: any = null;
        let agentResponseCount = 0;
        for (let i = this.messages.length - 1; i >= 0; i--) {
          const msg = this.messages[i];

          // Stop traversing backward if we hit a user message, isolating the search to the current response cycle
          if (msg.type === 'user') {
            break;
          }

          if (msg.messageType === ChatMessageType.PLAN && msg.status !== ChatMessageStatus.COMPLETED) {
            latestPendingPlanMsg = msg;
            break;
          } else if (msg.messageType !== ChatMessageType.SHIMMER) {
            // so, max it would be from assistant
            agentResponseCount++;
            if (agentResponseCount >= 2) {
              break;
            }
          }
        }

        if (
          latestPendingPlanMsg &&
          !latestPendingPlanMsg.hasAutoOpened &&
          latestPendingPlanMsg.treeTableData &&
          latestPendingPlanMsg.treeTableData.length > 0
        ) {
          this.isChatDisabled = true;

          latestPendingPlanMsg.hasAutoOpened = true;
          const firstItemType = latestPendingPlanMsg.treeTableData[0]?.data?.itemType;

          // Use timeout to allow UI update to finish
          setTimeout(() => {
            if (firstItemType === 'datamodel') {
              this.openDataModelWithVisualizer(latestPendingPlanMsg.sid);
            } else if (firstItemType === 'page') {
              this.openPageVisualizer(latestPendingPlanMsg.sid);
            }
          }, 100);
        } else if (
          lastMsg.messageType === ChatMessageType.SHIMMER ||
          lastMsg.messageType === ChatMessageType.PLAN_OUTLINE
        ) {
          this.isChatDisabled = true;
        } else {
          this.isChatDisabled = false;
        }

        if (
          lastMsg.status === ChatMessageStatus.PENDING &&
          (lastMsg.messageType === ChatMessageType.QUESTION_AND_ANSWERS ||
            lastMsg.messageType === ChatMessageType.RECOMMENDATION)
        ) {
          setTimeout(() => {
            // scroll-down to card visible initially
            const chatBody = document.querySelector('.chat-body');
            if (chatBody) {
              chatBody.scrollTop = chatBody.scrollHeight;
            }
          }, 100);

          setTimeout(() => {
            // Ensure fully scrolled after grid animation completes
            const chatBody = document.querySelector('.chat-body');
            if (chatBody) {
              chatBody.scrollTop = chatBody.scrollHeight;
            }
          }, 650);

          this.isSessionSummaryExpanded = false;
          this.isQnADomStateActive = true;
          // Delay turning on visibility so the *ngIf DOM insertion happens first, allowing the CSS transition to run
          setTimeout(() => {
            this.isQnACardVisible = true;
          }, 150);
          this.QnAChatMessage = lastMsg;
        }

        if (
          lastMsg.messageType === ChatMessageType.AGENT_RESPONSE ||
          lastMsg.messageType === ChatMessageType.RECOMMENDATION
        ) {
          this.Flags.isSessionActionsDisabled = false;
        } else {
          /*
            User_response
              > then, agent will be thinkking and will give response as one of below

              @ideate-session
                SHIMMER
                QUESTION_AND_ANSWERS
                RECOMMENDATION

              @build-session
                SHIMMER
                PLAN_OUTLINE: it will be followed by PLAN
                PLAN: Use 'refine'

            So, exception is 'AGENT_RESPONSE'only
            > It may be completed user's query-response cycle or in-btw asked as question awaiting answer from User
            > So, we may have to discuss with Agent team to always emit question as Recommendation-card or QnA-card to overcome it
          */

          this.Flags.isSessionActionsDisabled = true;
        }
      }

      this.publishChatPendingFromLastMessage();

      this.showPendingPlanOutlineMsgAsPinned();
    }

    console.log('@updateChatMessages - ', this.messages);

    this.changeDetectorRef.detectChanges();
  }

  /**
   * Single source of truth for the shared "chat pending" flag, derived from the
   * latest message. Editing in dependent screens (e.g. functional design) is
   * blocked only while the AI is actively working or awaiting an interaction.
   */
  private publishChatPendingFromLastMessage(): void {
    const finalMsg = this.messages[this.messages.length - 1];

    if (!finalMsg) {
      this.appGlobalService.setChatPending(false);
      return;
    }

    const isUserMessage = finalMsg.type === 'user';
    const isAwaitingInteraction =
      finalMsg.status === ChatMessageStatus.PENDING &&
      (finalMsg.messageType === ChatMessageType.QUESTION_AND_ANSWERS || finalMsg.messageType === ChatMessageType.PLAN);
    const isAiWorking =
      finalMsg.messageType === ChatMessageType.SHIMMER ||
      finalMsg.messageType === ChatMessageType.PLAN_OUTLINE ||
      !!finalMsg.isActionInProgress;

    const isPending = isUserMessage || isAwaitingInteraction || isAiWorking;

    this.appGlobalService.setChatPending(isPending);
  }

  extractContentText(thatContent: any) {
    // Check if stringified JSON
    if (typeof thatContent === 'string' && thatContent.trim().startsWith('{')) {
      try {
        const parsed = JSON.parse(thatContent);
        if (parsed.text) {
          return parsed.text;
        }
      } catch (e) {
        console.log(' Not valid JSON, return as is');
      }
    }

    return thatContent;
  }

  /**
   * Helper function to extract text content from potentially structured backend messages.
   * Handles both JSON strings and objects.
   * Usage: In HTML template: {{ getDisplayText(msg) }}
   */
  getDisplayText(msg: any): string {
    const content =
      msg.type === 'assistant' && msg.displayedText !== undefined ? msg.displayedText : msg.text || msg.content;

    if (!content) {
      return '';
    }

    // Check if object
    if (typeof content === 'object' && content !== null && content.text) {
      return content.text;
    }

    return this.extractContentText(content);
  }

  getCopyText(msg: any): string {
    if (msg.messageType === ChatMessageType.QUESTION_AND_ANSWERS && msg.status === ChatMessageStatus.COMPLETED) {
      if (Array.isArray(msg.content)) {
        return msg.content
          .map((item: any) => {
            if (item.skippedAll) {
              return `Skipped All Questions\nReason: ${item.answer || ''}`;
            }
            return `Q: ${item.questionText || ''}\nA: ${item.answer || ''}`;
          })
          .join('\n\n')
          .trim();
      }
    }

    // If msg.text evaluates to an object string like "[object Object]", fallback to getDisplayText
    if (msg.text === '[object Object]') {
      return this.getDisplayText(msg);
    }

    return msg.text || this.getDisplayText(msg) || '';
  }

  getActionTakenLabel(msg: any): string {
    return this.extractContentText(msg.content) || '';
  }

  toggleCollapse(msg: ChatMessage) {
    msg.isCollapsed = !msg.isCollapsed;
    msg.userToggled = true; // Mark as user toggled to prevent auto-collapse
  }

  /**
   * Helper function for word-by-word streaming of assistant text
   */
  /**
   * Helper function for word-by-word streaming of assistant text
   */
  private startStreaming(msg: ChatMessage) {
    if (!msg.sid) {
      return;
    }

    // Check if ANY message is already streaming
    const isAnyStreaming = Array.from(this.streamingIntervals.values()).length > 0;

    if (isAnyStreaming && !this.streamingIntervals.has(msg.sid)) {
      // If a different message is streaming, queue this one if not already queued
      if (!this.messageQueue.find((m) => m.sid === msg.sid)) {
        this.messageQueue.push(msg);
      }
      return;
    }

    const targetText = msg.text || '';
    if (!targetText) {
      msg.displayedText = '';
      this.checkQueue();
      return;
    }

    console.log('targetText: ', targetText);
    const words = targetText.split(' ');
    // Pick up from where we currently are
    const currentWords = (msg.displayedText || '').split(' ').filter((w) => w !== '');
    let currentWordIndex = currentWords.length;

    // IF already complete, snap to end and bail
    if (currentWordIndex >= words.length && msg.displayedText === targetText) {
      msg.isStreaming = false;
      this.checkQueue();
      return;
    }

    msg.isStreaming = true;

    const intervalId = setInterval(() => {
      if (currentWordIndex < words.length) {
        msg.displayedText = words.slice(0, currentWordIndex + 1).join(' ');
        currentWordIndex++;
        this.changeDetectorRef.detectChanges();
      } else {
        msg.isStreaming = false;
        clearInterval(intervalId);
        this.streamingIntervals.delete(msg.sid!);

        this.changeDetectorRef.detectChanges();

        // Check if there are other messages waiting to stream
        this.checkQueue();
      }
    }, this.getStreamingSpeed()); // Adaptive speed based on queue length

    this.streamingIntervals.set(msg.sid, intervalId);
  }

  /**
   * Calculates streaming speed based on total pending messages.
   * Standard: 200ms
   * Accelerated: 50ms - 150ms depending on how many messages are waiting/streaming
   */
  private getStreamingSpeed(): number {
    // Count both messages in queue AND any messages currently streaming
    const queueLength = this.messageQueue.length;
    const streamingCount = this.streamingIntervals.size;
    const totalPending = queueLength + streamingCount;

    if (totalPending <= 1) {
      return 100;
    }

    // Reduce interval based on total workload, min 40ms
    const speed = Math.max(40, 100 - (totalPending - 1) * 40);
    const timestamp = new Date().toISOString().split('T')[1];

    return speed;
  }

  /**
   * Check if there are messages in the queue and start streaming the next one
   */
  private checkQueue() {
    if (this.messageQueue.length > 0) {
      const nextMsg = this.messageQueue.shift();
      if (nextMsg) {
        if (nextMsg.messageType && this.skipStreaming[nextMsg.messageType]) {
          nextMsg.isStreaming = false;
          this.checkQueue();
        } else {
          this.startStreaming(nextMsg);
        }
      }
    }
  }

  /**
   * Unsubscribe from existing Firebase listeners
   */
  private unsubscribeFromChat() {
    console.warn('main-layout.component.ts: unsubscribeFromChat - subscriptions will be CLEARED');
    this.messageSub?.unsubscribe();
    this.conversationSub?.unsubscribe();

    this.firestoreMessagesMap.clear();
    this.firestoreConversationMap.clear();
  }

  /**
   * trackBy function for session list
   */
  trackBySession(index: number, session: any): string {
    return session.sid || index;
  }

  private checkRoute() {
    const appId = this.route.snapshot.paramMap.get('appId');
    this.isAppManagementPage = appId === 'appId';
    if (this.isAppManagementPage) {
      // Reset when going back to management page
      this.currentAppId = '';
    }
  }

  /**
   * Toggles user menu dropdown
   */
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  /**
   * Handles actions from chat messages (buttons)
   */
  handleMessageAction(action: ChatAction, index?: number, extraPayload?: any) {
    if (action.disabled) {
      return;
    }

    const msg = typeof index === 'number' ? this.messages[index] : null;

    // Immediately disable all actions in this message when any action (Reject/Change/Accept) is clicked
    if (msg) {
      msg.isActionInProgress = true;
      msg.iconActions?.forEach((a) => (a.disabled = true));
      msg.leftActions?.forEach((a) => (a.disabled = true));
      msg.rightActions?.forEach((a) => (a.disabled = true));
      this.appGlobalService.setChatPending(true);
    }

    // Complementary AIChatAction for plan buttons (proceed/reject) and QnA
    if (msg?.messageType === ChatMessageType.PLAN || msg?.messageType === ChatMessageType.QUESTION_AND_ANSWERS) {
      if (action.code === 'refine') {
        this.isChangeMode = true;
        this.changeRequestMessageIndex = index ?? null;
        this.changeRequestAction = action;

        // Determine what to change based on the content or headers
        this.changeRequestTarget = this.translate.instant('WHAT_WOULD_YOU_LIKE_TO_CHANGE');

        this.isChatDisabled = false;

        // Focus the textarea
        setTimeout(() => {
          this.chatTextarea?.nativeElement?.focus();
        }, 100);
      } else {
        this.clearCompanionOriginIfActive(msg);

        // Optimistic UI for all Actions (QnA, Accept, Reject, etc.)
        // ARCHITECTURAL NOTE: We INTENTIONALLY skip calling this.updateChatMessages() here!
        // Calling updateChatMessages() rebuilds the entire array, recalculates groups, and causes severe UI flickering/scroll-loss.
        // Instead, we directly mutate the local UI `msg` object to freeze the loading state *instantly*,
        // and sync it into `firestoreMessagesMap` so that future reactive redraws (via Firebase/SSE) preserve our locally applied state.
        if (msg) {
          msg.status = ChatMessageStatus.COMPLETED;
          msg.actionTaken = action;

          if (extraPayload) {
            if (!msg.content) msg.content = {};

            // For QnA, we MUST transform the content strictly into the expected Array format for the *ngFor loop
            if (msg.messageType === ChatMessageType.QUESTION_AND_ANSWERS && action.code === 'submit_qna') {
              // Pick corresponding property based on action type instead of blindly forwarding
              const qnaPayload = extraPayload.qnaPayload;

              if (qnaPayload) {
                const questions = msg.content.questions;
                if (questions && Array.isArray(questions)) {
                  // Instantly overwrite content with the formatted array to prevent NG02200 errors
                  const formatted = this.formatQAAnswers(questions, qnaPayload);
                  msg.content = formatted;
                  msg.isCollapsed = true;
                } else {
                  Object.assign(msg.content, qnaPayload);
                }
              }
            } else {
              // Standard actions: merge selectively or whitelist properties here in the future
              // Currently fallback for non-QnA extraPayload if any
              Object.assign(msg.content, extraPayload);
            }
          }

          // Also update the firestore cache so formatting sticks and prevents flickering
          if (msg.sid && this.firestoreMessagesMap.has(msg.sid)) {
            const mapMsg = this.firestoreMessagesMap.get(msg.sid);
            mapMsg.status = ChatMessageStatus.COMPLETED;
            mapMsg.actionTaken = action;

            if (extraPayload) {
              if (!mapMsg.content) mapMsg.content = {};

              if (mapMsg.messageType === ChatMessageType.QUESTION_AND_ANSWERS && action.code === 'submit_qna') {
                const qnaPayload = extraPayload.qnaPayload;

                if (qnaPayload) {
                  const questions = mapMsg.content.questions;
                  if (questions && Array.isArray(questions)) {
                    mapMsg.content = this.formatQAAnswers(questions, qnaPayload);
                  } else {
                    Object.assign(mapMsg.content, qnaPayload);
                  }
                }
              } else {
                Object.assign(mapMsg.content, extraPayload);
              }
            }
          }
        }

        const finalMsg = this.messages[this.messages.length - 1];
        const payload: any = {
          conversationId: finalMsg.conversationId,
          sessionId: this.sessionId,
          referenceMessageId: (finalMsg as any)?.sid,
          actionTaken: { label: action.label, code: action.code },

          mode: this.activeSession.mode,
          driven: this.activeSession.driven
        };

        if (action.code !== 'submit_qna') {
          payload.messageId = uuidv4();
        }

        if (extraPayload) {
          if (extraPayload.qnaPayload) {
            payload.content = extraPayload.qnaPayload;
          }
        }

        if (this.chatboxMode) {
          payload.chatboxMode = this.chatboxMode;
        }

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const currentSessionId = this.sessionId;

        let endpoint = ApiConstants.companionChatResume;

        this.httpBaseService[endpoint.method](endpoint, payload, { headers }).subscribe({
          error: (err) => {
            console.error('main-layout.component.ts: handle_MessageAction - AIChatAction Error:', err);

            if (this.sessionId === currentSessionId) {
              this.utilService.showError(
                this.translate.instant('ACTION_FAILED'),
                this.translate.instant('FAILED_TO_TRIGGER_ACTION', { action: action.code })
              );
              if (msg) {
                msg.isActionInProgress = false;
                msg.iconActions?.forEach((a) => (a.disabled = false));
                msg.leftActions?.forEach((a) => (a.disabled = false));
                msg.rightActions?.forEach((a) => (a.disabled = false));
              }
              this.appGlobalService.setChatPending(false);
            }
          }
        });
      }
    } else if (msg?.messageType === ChatMessageType.RECOMMENDATION) {
      // To hide QnA card
      msg.status = ChatMessageStatus.COMPLETED;

      // trigger chat/create with new conversation
      // forward recommendation:{conversationId, messageId}

      this.onSubmitRecommendationCard({
        extraPayload: extraPayload
      });
    }

    this.changeDetectorRef.detectChanges();
  }

  /**
   * Toggles message content collapse
   */
  toggleMessageCollapse(msg: ChatMessage) {
    msg.isCollapsed = !msg.isCollapsed;
  }

  /**
   * Handles Enter key press in textarea
   * - Enter alone: Send message
   * - Shift+Enter: New line
   */
  handleEnterKey(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSendMessage();
    }
    // If Shift+Enter, allow default behavior (new line)
  }

  /**
   * Auto-grows textarea height based on content
   * Up to 5 rows, then shows scrollbar
   */
  autoGrowTextarea(event?: Event) {
    if (!this.chatTextarea?.nativeElement) {
      return;
    }
    const textarea = event ? (event.target as HTMLTextAreaElement) : this.chatTextarea.nativeElement;
    textarea.style.height = this.promptboxHeight; // Reset to min-height
    let computedMax = Number.parseFloat(getComputedStyle(textarea).maxHeight);
    if (Number.isNaN(computedMax)) {
      computedMax = 120;
    } // fallback

    const newHeight = Math.min(textarea.scrollHeight, computedMax);
    textarea.style.height = `${newHeight}px`;
  }

  /**
   * Toggles chatbox mode and triggers text wrap recalculation
   */
  toggleChatboxMode(mode: 'ideate' | 'auto') {
    this.chatboxMode = this.chatboxMode === mode ? null : mode;
    // Allow DOM to update button width, then recalculate text wrapping

    if (!this.isNewSessionActive) {
      this.onSwitchSessionDriven();
    }

    setTimeout(() => {
      this.autoGrowTextarea();
    }, 0);
  }

  /**
   * Toggles chat panel collapse state
   */
  toggleChat() {
    this.isChatCollapsed = !this.isChatCollapsed;
    if (this.isChatCollapsed) {
      this.isContentCollapsed = false;
    } else {
      // Always restore to the default expanded width when expanding via toggle.
      this.chatWidth = 420;
    }

    this.headerService.setChatCollapsedState(this.isChatCollapsed);
    this.syncVibeLayoutWidth();
  }

  /**
   * Opens the sessions panel
   */
  onOpenSessionPanel() {
    this.isSessionConfirmationPending = false;
    this.isNewSessionActive = false;
    this.isSessionSummaryExpanded = false;
    this.headerService.setNewSessionActiveState(false);
    this.blueprintStateService.setChangesetMarkers({});

    this.isQnACardVisible = false;
    this.isQnADomStateActive = false;
    this.sessionConfirmationType = null;

    this.sessionDetailSub?.unsubscribe();
    this.blueprintDetailSub?.unsubscribe();
    this.appDetailSub?.unsubscribe();

    if (this.isSessionsPanelOpen) {
      return;
    }

    // Switch to blueprint-project-charter in title-bar and revise RHS content, strip sessionId
    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');
    this.router.navigate(['/home', orgId, appId, 'blueprint', 'project-charter'], {
      queryParams: { sessionId: null },
      queryParamsHandling: 'merge'
    });

    this.sessionId = '';
    this.appGlobalService.setSessionId('');

    this.resetChatStateAndExpand();
    // Pass true to force the list to display instead of auto-resuming a URL or single session
    this.listenToSessionsList(true);
  }

  onRejectSession() {
    this.closeQnACard();
    this.isSessionConfirmationPending = true;
    this.sessionConfirmationType = 'reject';
    this.isSessionSummaryExpanded = false;
    this.isChatDisabled = true;

    setTimeout(() => {
      const chatBody = document.querySelector('.chat-body');
      if (chatBody) {
        chatBody.scrollTop = chatBody.scrollHeight;
      }
    }, 100);
  }

  onApproveSession() {
    this.closeQnACard();
    this.isSessionConfirmationPending = true;
    this.sessionConfirmationType = 'approve';
    this.isSessionSummaryExpanded = false;
    this.isChatDisabled = true;

    setTimeout(() => {
      const chatBody = document.querySelector('.chat-body');
      if (chatBody) {
        chatBody.scrollTop = chatBody.scrollHeight;
      }
    }, 100);
  }

  resolveSessionConfirmation(isConfirmed: boolean) {
    if (!isConfirmed) {
      // user opted for NO in either ApproveBP or DiscardBP card

      this.isChatDisabled = false;

      this.isSessionConfirmationPending = false;
      this.sessionConfirmationType = null;
      return;
    }

    this.chatInput = '';
    this.removeAttachment();

    let endpoint = ApiConstants.companion.mergeSessionBP;

    this.isSessionConfirmationPending = false;

    let finalMsg = this.messages[this.messages.length - 1];

    let payload: any = {
      mergeAction: this.sessionConfirmationType,

      pathParams: {
        sessionId: this.activeSession.sid
      }
    };

    if (finalMsg.messageType === ChatMessageType.RECOMMENDATION) {
      payload.conversationId = finalMsg.conversationId;
      payload.referenceMessageId = finalMsg.sid;
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    this.httpBaseService[endpoint.method](endpoint, payload, { headers }).subscribe();

    if (this.sessionConfirmationType === 'approve') {
      this.activeSession.mergeStatus = SESSION_MERGE_STATUS.IN_PROGRESS;
    } else {
      this.onOpenSessionPanel();
    }
  }

  onSwitchSessionDriven() {
    let endpoint = ApiConstants.companion.updateSession;

    let payload = {
      driven: this.chatboxMode === 'auto' ? SESSION_DRIVEN_MODE.AUTO : SESSION_DRIVEN_MODE.MANUAL,

      pathParams: {
        sessionId: this.sessionId
      }
    };

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    this.httpBaseService[endpoint.method](endpoint, payload, { headers }).subscribe();
  }

  onDiscardBuildSession() {
    this.onOpenSessionPanel();
  }

  onAcceptBuildSession() {
    let endpoint = ApiConstants.companion.updateSession;

    let payload = {
      isBuildSessionInitiated: true,
      pathParams: {
        sessionId: this.sessionId
      }
    };

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    this.httpBaseService[endpoint.method](endpoint, payload, { headers }).subscribe({
      next: () => {
        this.activeSession.isBuildSessionInitiated = true;

        this.createNewBuildSession();
      }
    });
  }

  createNewBuildSession() {
    let endpoint = ApiConstants.companionChatCreate;

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const payload: any = {
      sessionId: uuidv4(),
      sessionName: 'Build: ' + this.activeSession.sessionName,
      conversationId: uuidv4(),
      content: {
        text: 'Build Now'
      },
      messageId: uuidv4(),

      mode: SESSION_MODE.BUILD,
      driven: SESSION_DRIVEN_MODE.MANUAL
    };

    this.httpBaseService[endpoint.method](endpoint, payload, { headers }).subscribe();

    this.switchToSession(payload);
  }

  switchToSession(payload) {
    setTimeout(() => {
      this.resetChatStateAndExpand();
      this.resetConnections();

      const orgId = this.appGlobalService.get('orgId');
      const appId = this.appGlobalService.get('appId');

      this.router.navigate(['/home', orgId, appId, 'blueprint', 'project-charter'], {
        queryParams: { sessionId: payload.sessionId },
        queryParamsHandling: 'merge'
      });

      this.resumeSessionById(payload.sessionId);
    }, 1500);
  }

  /**
   * Toggles search overlay visibility
   */
  toggleSearchOverlay() {
    if (!this.isSearchDisabled) {
      this.isSearchOverlayOpen = !this.isSearchOverlayOpen;
    }
  }

  /**
   * Cancels the change request mode
   */
  cancelChangeMode() {
    if (this.changeRequestMessageIndex !== null && this.messages[this.changeRequestMessageIndex]) {
      const msg = this.messages[this.changeRequestMessageIndex];
      msg.isActionInProgress = false;
      msg.iconActions?.forEach((a) => (a.disabled = false));
      msg.leftActions?.forEach((a) => (a.disabled = false));
      msg.rightActions?.forEach((a) => (a.disabled = false));
    }
    this.isChangeMode = false;
    this.chatInput = '';
    setTimeout(() => {
      if (this.chatTextarea?.nativeElement) {
        this.chatTextarea.nativeElement.style.height = this.promptboxHeight;
      }
    }, 0);
    this.changeRequestMessageIndex = null;
    this.changeRequestAction = null;
    this.changeRequestTarget = '';
    this.isChatDisabled = true;
  }

  /**
   * Wrapper to explicitly reset all companion change sets in the global state
   */
  resetCompanionChangeSets() {
    this.appGlobalService.write('companionMessageChangeset_datamodel', {});
    this.appGlobalService.write('companionMessageChangeset_page', {});
  }

  /**
   * Clears companionMessageChangeset_datamodel and navigates away from visualizer origins back to basic datamodel route
   * Clear companion data and restore view without origin if action is anything other than 'refine' (refine is handled on send)
   */
  clearCompanionOriginIfActive(msg?: any) {
    this.resetCompanionChangeSets();
    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');

    if (orgId && appId) {
      let targetRoute: string[] | null = null;

      if (msg?.plan?.artifacts) {
        const artifacts = msg.plan.artifacts;
        const hasDataModel =
          artifacts.datamodel &&
          (artifacts.datamodel.create || artifacts.datamodel.update || artifacts.datamodel.delete);
        const hasPage = artifacts.page && (artifacts.page.create || artifacts.page.update || artifacts.page.delete);

        if (hasDataModel) {
          targetRoute = ['/home', orgId, appId, 'designs', 'datamodel'];
        } else if (hasPage) {
          targetRoute = ['/home', orgId, appId, 'prototyping', 'screens'];
        }
      }

      if (targetRoute) {
        this.router.navigate(targetRoute, {
          queryParams: { t: new Date().getTime() }
        });
      }
    }
  }

  onSubmitRecommendationCard(config: any) {
    let recommendationAnswer: any;

    let endpoint = ApiConstants.companion.createConversation;

    let finalMsg = this.messages[this.messages.length - 1];

    let questionId = finalMsg.content.questions[0].id;

    if (config.extraPayload?.qnaPayload?.answers) {
      recommendationAnswer = config.extraPayload.qnaPayload.answers[questionId];

      if (recommendationAnswer) {
        recommendationAnswer = finalMsg.content.questions[0].options.find((o: any) => o.id === recommendationAnswer);
        recommendationAnswer = recommendationAnswer.text;
      }
    }

    if (!recommendationAnswer && config.extraPayload?.qnaPayload?.otherAnswers) {
      recommendationAnswer = config.extraPayload.qnaPayload.otherAnswers[questionId] || '';

      if (Array.isArray(recommendationAnswer) && recommendationAnswer.length > 0) {
        recommendationAnswer = recommendationAnswer[0];
      }
    }

    const payload: any = {
      conversationId: finalMsg.conversationId,
      sessionId: this.activeSession.sid,

      messageId: uuidv4(),
      referenceMessageId: finalMsg.sid,

      actionTaken: {
        code: 'submit_recommendation'
      },

      content: {
        text: recommendationAnswer
      },

      mode: this.activeSession.mode,
      driven: this.activeSession.driven
    };

    this.isChatDisabled = true;
    this.chatInput = '';
    setTimeout(() => {
      if (this.chatTextarea?.nativeElement) {
        this.chatTextarea.nativeElement.style.height = this.promptboxHeight;
      }
    }, 0);

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    // Optimistic UI Update: Create a pending message to show immediately
    const pendingMsg: any = {
      sid: payload.messageId,
      conversationId: payload.conversationId,
      sessionId: this.sessionId,
      content: JSON.stringify({ text: recommendationAnswer }),
      role: 'user',
      createdDate: new Date(),
      status: ChatMessageStatus.COMPLETED,
      messageType: ChatMessageType.USER_RESPONSE
    };

    this.firestoreMessagesMap.set(payload.messageId, pendingMsg);
    this.updateChatMessages(Array.from(this.firestoreMessagesMap.values()));

    this.httpBaseService[endpoint.method](endpoint, payload, { headers }).subscribe({
      next: () => {
        // Recommendation chat created successfully
      },
      error: (err) => {
        console.error('Error creating chat for recommendation:', err);
      }
    });
  }

  removeAttachment(): void {
    this.attachedFile = null;
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = ''; // Reset input to allow selecting same file again
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) {
      return;
    }

    const file = input.files[0];

    // Validate type limit
    const validTypes = ['application/pdf'];
    if (!validTypes.includes(file.type)) {
      this.utilService.showError('Invalid File', 'Please upload a PDF or TXT file.');
      input.value = ''; // clear
      return;
    }

    // Validate size limit (10MB max)
    const MAX_SIZE = 10 * 1024 * 1024;
    if (file.size > MAX_SIZE) {
      this.utilService.showError('File Too Large', 'File exceeds the 10MB size limit.');
      input.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = (e: any) => {
      let base64String = e.target.result;
      // Strip out the data URL prefix if present (e.g., "data:application/pdf;base64,")
      if (base64String.includes(',')) {
        base64String = base64String.split(',')[1];
      }

      this.attachedFile = {
        name: file.name,
        type: file.type,
        content: base64String
      };
    };

    reader.readAsDataURL(file);
  }

  onSendMessage() {
    const input = this.chatInput.trim();

    if (!input && !this.attachedFile) {
      return;
    }

    const finalMsg = this.messages[this.messages.length - 1];

    const msgId = uuidv4();

    let appendProxyMessageInUI = false;

    let endpoint: any = ApiConstants.companionChatResume;

    const payload: any = {
      sessionId: this.sessionId,
      messageId: msgId,
      content: {}
    };

    if (input) {
      payload.content.text = input;

      appendProxyMessageInUI = true;
    }

    if (this.attachedFile) {
      payload.attachments = [this.attachedFile];
    }

    if (finalMsg?.messageType === ChatMessageType.RECOMMENDATION && finalMsg?.status === ChatMessageStatus.PENDING) {
      payload.conversationId = finalMsg.conversationId;
      payload.mode = this.activeSession.mode;
      payload.driven = this.activeSession.driven;
      payload.referenceMessageId = (finalMsg as any)?.sid;

      endpoint = ApiConstants.companion.createConversation;
    } else {
      const isConversationsCompleted =
        !finalMsg ||
        !finalMsg.conversationId ||
        this.firestoreConversationMap.get(finalMsg.conversationId)?.status === CONVERSATION_STATUS.COMPLETED;

      if (isConversationsCompleted) {
        payload.conversationId = uuidv4();

        endpoint = ApiConstants.companion.createConversation;

        if (this.isNewSessionActive) {
          let uiInfo: any = {
            isIdeateMode: this.chatboxMode === 'ideate',
            isBuildMode: this.chatboxMode !== 'ideate',
            isAutoMode: this.chatboxMode === 'auto'
          };

          if (uiInfo.isIdeateMode) {
            payload.mode = SESSION_MODE.IDEATE;
          } else {
            payload.mode = SESSION_MODE.BUILD;

            if (uiInfo.isAutoMode) {
              payload.driven = SESSION_DRIVEN_MODE.AUTO;
            } else {
              payload.driven = SESSION_DRIVEN_MODE.MANUAL;
            }
          }
        } else {
          payload.mode = this.activeSession.mode;
          payload.driven = this.activeSession.driven;
        }

        if (!this.sessionId) {
          this.sessionId = uuidv4();

          endpoint = ApiConstants.companionChatCreate;

          payload.sessionId = this.sessionId;

          if (!this.isNewSessionActive) {
            // Switch to blueprint on RHS and update URL
            const orgId = this.appGlobalService.get('orgId');
            const appId = this.appGlobalService.get('appId');
            this.router.navigate(['/home', orgId, appId, 'blueprint', 'project-charter'], {
              queryParams: { sessionId: this.sessionId },
              queryParamsHandling: 'merge'
            });

            this.listenToChatEvents({});
          }
        }
      } else {
        payload.referenceMessageId = (finalMsg as any)?.sid;

        payload.mode = this.activeSession.mode;
        payload.driven = this.activeSession.driven;
        payload.conversationId = finalMsg.conversationId;
      }
    }

    if (appendProxyMessageInUI) {
      // Optimistic UI Update: Create a pending message to show immediately
      const pendingMsg: any = {
        sid: msgId,
        conversationId: payload.conversationId,
        sessionId: this.sessionId,
        content: JSON.stringify({ text: input }),
        role: 'user',
        createdDate: new Date(),
        status: ChatMessageStatus.PENDING,
        messageType: ChatMessageType.USER_RESPONSE
      };

      if (!this.isNewSessionActive) {
        this.firestoreMessagesMap.set(msgId, pendingMsg);
        this.updateChatMessages(Array.from(this.firestoreMessagesMap.values()));
      }
    }

    // Add specific payload data for Change Mode
    if (this.isChangeMode && this.changeRequestAction) {
      payload.actionTaken = { label: this.changeRequestAction.label, code: this.changeRequestAction.code };
      if (this.changeRequestAction.code === 'refine') {
        const changeMsgIndex = this.changeRequestMessageIndex;
        const targetMsg = changeMsgIndex !== null ? this.messages[changeMsgIndex] : null;
        this.clearCompanionOriginIfActive(targetMsg);
      }
    }

    this.isChatDisabled = true;
    this.appGlobalService.setChatPending(true);

    // UI Feedback: disable actions on the target message if in change mode
    const changeMsgIndex = this.changeRequestMessageIndex;
    const targetMsg = this.isChangeMode && changeMsgIndex !== null ? this.messages[changeMsgIndex] : null;

    if (targetMsg) {
      targetMsg.isActionInProgress = true;
      targetMsg.leftActions?.forEach((action) => (action.disabled = true));
      targetMsg.rightActions?.forEach((action) => (action.disabled = true));
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    // Moved out from response-call-back, since below HTTP request will take more time to complete and in-btw we'll receive it in Message objects
    // But, expecting there will be a delay of 3-8s
    this.chatInput = '';
    this.removeAttachment();
    setTimeout(() => {
      if (this.chatTextarea?.nativeElement) {
        this.chatTextarea.nativeElement.style.height = this.promptboxHeight;
      }
    }, 0);

    if (this.isChangeMode) {
      this.resetChangeMode();
    }

    const currentSessionId = this.sessionId;

    this.httpBaseService[endpoint.method](endpoint, payload, { headers }).subscribe({
      error: (err) => {
        console.error('main-layout.component.ts: sendMessage - Error:', err);

        if (this.sessionId === currentSessionId) {
          this.utilService.showError(
            this.translate.instant('MESSAGE_FAILED'),
            this.translate.instant('FAILED_TO_SEND_MESSAGE')
          );

          this.isChatDisabled = false;

          // Rollback UI feedback for Change Mode
          if (targetMsg) {
            targetMsg.isActionInProgress = false;
            targetMsg.leftActions?.forEach((action) => (action.disabled = false));
            targetMsg.rightActions?.forEach((action) => (action.disabled = false));
          }
          this.appGlobalService.setChatPending(false);
        }
      }
    });

    if (this.isNewSessionActive) {
      setTimeout(() => {
        // when triggered immediately, getting error. So, added jitters
        this.resumeSessionById(payload.sessionId);
      }, 1500);
    } else {
      // Reset new session active state upon actual submission constraint
      this.headerService.setNewSessionActiveState(false);
    }
  }

  viewDetails(app: Application) {
    this.selectedApp = app;
    this.detailedDialogVisible = true;
  }

  updateApplication(updatedApp: any) {
    this.store
      .select(currentAppFullData)
      .pipe(take(1))
      .subscribe({
        next: (currentAppResponse) => {
          this.store.dispatch(
            sentApps({
              getAppsApiConstants: ApiConstants.updateAppById,
              saveAppsData: { ...currentAppResponse, ...updatedApp }
            })
          );
        },
        error: (err) => {
          console.error(
            'main-layout.component.ts: @update_Application() - Action: EditApplication => Result: Error',
            err
          );
        }
      });

    // Handle dialog closure or state reset on success/error
    this.store
      .select(updateStatus)
      .pipe(
        filter((status) => status === true),
        take(1)
      )
      .subscribe({
        next: (status) => {
          this.detailedDialogVisible = false;
        },
        error: (err) => {
          console.error(
            'main-layout.component.ts: @update_Application() - Action: EditApplication => Result: Error',
            err
          );
        }
      });

    this.store
      .select(newlyCreatedAppErr)
      .pipe(
        filter((err) => !!err),
        take(1)
      )
      .subscribe({
        next: (err) => {
          console.error(
            'main-layout.component.ts: @update_Application() - Action: selector:newlyCreatedAppErr => Result: Error',
            err
          );
          // If error occurs, the component stays open and recovers via ngOnChanges
          // which resets isUpdating and enables the form
        },
        error: (error) => {
          console.error(
            'main-layout.component.ts: @update_Application() - Action: selector:newlyCreatedAppErr => Result: Error',
            error
          );
        }
      });
  }

  handleActiveItemClick(itemId: string) {
    this.isContentCollapsed = !itemId;

    // Auto-update box layout state if needed, handled by variable binding
  }

  updateIsBetaAccessPrivilegeConsumable() {
    this.isBetaAccessPrivilegeConsumable = this.appGlobalService.isBetaAccessPrivilegeConsumableForApp();

    this.isBetaAccessPrivilegeConsumableForUser = this.appGlobalService.isBetaAccessPrivilegeConsumableForUser();

    this.syncVibeLayoutWidth();

    this.changeDetectorRef.detectChanges();
  }

  private syncVibeLayoutWidth(): void {
    if (!this.isBetaAccessPrivilegeConsumable) {
      document.documentElement.style.removeProperty('--vibe-left-rail-width');
      return;
    }

    const railWidth = this.isChatCollapsed ? this.collapsedChatWidth - 20 : this.chatWidth - 20;
    document.documentElement.style.setProperty('--vibe-left-rail-width', `${railWidth}px`);
  }

  /**
   * Builds TreeNode data structure from tableCards for tree table display
   * Tables are parent nodes, fields are children - all selected by default
   */
  buildTreeTableData(
    tableCards: {
      tableName: string;
      oldTableName?: string;
      fields: { name: string; oldName?: string; type: string; isNew?: boolean; isDelete?: boolean }[];
      expanded?: boolean;
      type?: string;
      isUpdate?: boolean;
      isOnlyDelete?: boolean;
      isTableDelete?: boolean;
      hasAdd?: boolean;
      hasEdit?: boolean;
      hasDelete?: boolean;
    }[]
  ): {
    treeData: TreeNode[];
  } {
    const treeData: TreeNode[] = [];

    tableCards.forEach((table, tIndex) => {
      const childNodes: TreeNode[] = table.fields?.map((field, fIndex) => {
        const key = `${tIndex}-${fIndex}`;

        return {
          key: key,
          data: {
            name: field.name,
            oldName: field.oldName,
            type: field.type,
            isField: true,
            disabled: true,
            isNew: field.isNew,
            isDelete: field.isDelete
          }
        };
      });

      const parentKey = `${tIndex}`;

      const parentNode: TreeNode = {
        key: parentKey,
        data: {
          name: table.tableName,
          oldTableName: table.oldTableName,
          type: table.type === 'page' ? 'PAGE' : 'TABLE',
          itemType: table.type, // Store original type
          isField: false,
          disabled: true,
          isUpdate: table.isUpdate,
          isOnlyDelete: table.isOnlyDelete,
          isTableDelete: table.isTableDelete,
          hasAdd: table.hasAdd,
          hasEdit: table.hasEdit,
          hasDelete: table.hasDelete
        },
        children: childNodes,
        expanded: false
      };

      treeData.push(parentNode);
    });

    return { treeData };
  }

  /**
   * Toggles expand/collapse state of a tree node
   */
  toggleNode(node: TreeNode, msgIndex: number): void {
    node.expanded = !node.expanded;
    // Force change detection by creating a new array reference
    const msg = this.messages[msgIndex];
    if (msg?.treeTableData) {
      msg.treeTableData = [...msg.treeTableData];
    }
  }

  openDataModelWithVisualizer(msgId?: string) {
    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');
    if (orgId && appId) {
      // Pre-populate changeset data in appGlobalService so data-model can read it without a Firestore call
      if (msgId) {
        const msg = this.messages.find((m) => m.sid === msgId);
        if (msg?.plan) {
          const dm = msg.plan?.artifacts?.datamodel;
          if (dm) {
            const ops: any[] = [];
            if (dm.create) {
              ops.push(...dm.create);
            }
            if (dm.update) {
              ops.push(...dm.update);
            }
            if (dm.delete) {
              ops.push(...dm.delete);
            }

            let companionMap = this.appGlobalService.get('companionMessageChangeset_datamodel');
            if (!companionMap || Array.isArray(companionMap)) {
              companionMap = {};
            }
            companionMap[msgId] = ops.length > 0 ? ops : null;
            this.appGlobalService.write('companionMessageChangeset_datamodel', companionMap);
          }
        }
      }
      this.router.navigate(['/home', orgId, appId, 'designs', 'datamodel'], {
        queryParams: { origin: 'companion', msgId: msgId, t: new Date().getTime() }
      });
    } else {
      console.warn('orgId or appId is missing');
    }
  }

  openPageVisualizer(msgId?: string) {
    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');
    if (orgId && appId) {
      if (msgId) {
        const msg = this.messages.find((m) => m.sid === msgId);
        if (msg?.plan) {
          const selectedPage = msg.plan?.artifacts?.page;
          if (selectedPage) {
            let companionMap = this.appGlobalService.get('companionMessageChangeset_page');
            if (!companionMap || Array.isArray(companionMap)) {
              companionMap = {};
            }
            companionMap[msgId] = selectedPage;
            this.appGlobalService.write('companionMessageChangeset_page', companionMap);
          }
        }
      }
      this.router.navigate(['/home', orgId, appId, 'prototyping', 'screens'], {
        queryParams: { origin: 'companion', msgId: msgId, t: new Date().getTime() }
      });
    } else {
      console.warn('orgId or appId is missing');
    }
  }

  resetChangeMode() {
    this.isChangeMode = false;
    this.changeRequestAction = null;
  }

  resetAppGlobalFlags() {
    // Clear flag after use
    this.appGlobalService.write('appCreated', false);
    this.appGlobalService.write('appPrompt', {});
  }

  get boxLayoutConfig() {
    return { isAppOpened: !this.isAppManagementPage };
  }

  /**
   * Initiates resize drag operation
   * @param event - Mouse event
   */
  startResizing(event: MouseEvent) {
    this.isResizing = true;
    this.lastResizeClientX = event.clientX;
    document.body.classList.add('rail-resizing');
    event.preventDefault();
  }

  copyConversationToClipboard(targetIndex: number): void {
    const targetMsg = this.messages[targetIndex];
    if (!targetMsg || !targetMsg.conversationId) return;

    const excludedTypes = [
      ChatMessageType.SHIMMER,
      ChatMessageType.PLAN,
      ChatMessageType.PLAN_OUTLINE,
      ChatMessageType.QUESTION_AND_ANSWERS,
      ChatMessageType.RECOMMENDATION
    ];

    const aggregatedMessages: string[] = [];

    // Traverse backwards starting from the target message index
    for (let i = targetIndex; i >= 0; i--) {
      const msg = this.messages[i];

      // Stop traversing if we hit a user message or different conversation
      if (msg.type === 'user' || msg.conversationId !== targetMsg.conversationId) {
        break;
      }

      // Ignore GUI cards and shimmer loaders
      if (msg.messageType && excludedTypes.includes(msg.messageType as any)) {
        continue;
      }

      // Check for available text (e.g. standard AGENT_RESPONSE or mapped text)
      const copyText = this.getCopyText(msg);
      if (copyText) {
        aggregatedMessages.push(copyText.trim());
      }
    }

    // Since we traversed backwards, reverse to maintain chronological order
    const finalCopiedText = aggregatedMessages.reverse().join('\n\n');

    if (finalCopiedText) {
      this.copyToClipboard(finalCopiedText);
    }
  }

  copyToClipboard(text: string | null | undefined): void {
    if (!text) {
      return;
    }
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.utilService.showMessage('success', this.translate.instant('COPIED_TO_CLIPBOARD'));
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  }

  getViewingSessionUser(): string {
    const createdBy = this.activeSession?.createdBy;
    if (createdBy && this.appMetaInfo?.[createdBy]) {
      return this.appMetaInfo[createdBy];
    }

    return this.activeSession?.userEmail || '';
  }

  setChangesetViewMode(mode: 'system_only' | 'session_and_system' | 'session_vs_system') {
    if (this.activeBPSession.SystemBP_FD.isEmpty && this.activeBPSession.SystemBP_PC.isEmpty) {
      this.utilService.showError('System Blueprint is empty. So, we cannot switch view');
    } else {
      this.changesetViewMode = mode;

      console.log(mode);

      this.blueprintStateService.setChangesetMarkers({
        viewMode: mode
      });
    }
  }

  openShareSessionDialog(sessionUrl: string) {
    this.dialogService.open(ShareSessionComponent, {
      header: this.translate.instant('SEND_MAIL'),
      width: '500px',
      data: { sessionUrl, activeSession: this.activeSession },
      closable: true,
      styleClass: 'form p-dialog'
    });
  }

  openRenameSessionDialog(session: any) {
    const dialogRef = this.dialogService.open(RenameSessionComponent, {
      header: this.translate.instant('RENAME_SESSION'),
      width: '400px',
      data: { session },
      closable: true,
      styleClass: 'form p-dialog'
    });

    dialogRef.onClose.subscribe((result) => {
      if (result && result.success) {
        // Update session name locally so the UI updates
        session.sessionName = result.sessionName;
      }
    });
  }

  get activeShimmerMessage(): ChatMessage | null {
    const finalMsg = this.messages[this.messages.length - 1];
    if (finalMsg?.messageType === ChatMessageType.SHIMMER && finalMsg?.status !== ChatMessageStatus.COMPLETED) {
      return finalMsg;
    }
    return null;
  }

  showPendingPlanOutlineMsgAsPinned(): void {
    this.pendingPlanOutlineMsg = null;
    this.pendingTodosStats = null;

    // Search backward to find if the latest PLAN_OUTLINE is pending
    for (let i = this.messages.length - 1; i >= 0; i--) {
      const msg = this.messages[i];
      if (msg.messageType === ChatMessageType.PLAN_OUTLINE) {
        // Find the most recent PENDING plan outline that actually contains sections
        if (msg.status === ChatMessageStatus.PENDING) {
          if (msg.content?.sections) {
            this.pendingPlanOutlineMsg = msg;

            const sections = msg.content.sections;
            const planName = msg.content.header?.title;

            if (sections && Array.isArray(sections) && sections.length > 0) {
              const stats: any[] = [];
              sections.forEach((sec: any) => {
                let total = 0;
                let completed = 0;
                let inProgressItemTitle = '';
                if (sec.items) {
                  total = sec.items.length;
                  completed = sec.items.filter((item: any) => item.status === 'successful').length;
                  let inProgressItems = sec.items.filter((item: any) => item.status === 'in-progress');
                  if (inProgressItems.length > 0) {
                    inProgressItemTitle = inProgressItems[0].text;
                  }
                }
                stats.push({ title: sec.title, total, completed, inProgressItemTitle });
              });
              this.pendingTodosStats = stats;
            }
          }
        }
        break; // Stop looking after finding the most recent PLAN_OUTLINE
      }
    }
  }

  closeQnACard() {
    this.isQnACardVisible = false;
    setTimeout(() => {
      this.isQnADomStateActive = false;
    }, 850);
  }

  onSubmitQnACard(qnaPayload: {
    answers?: Record<string, unknown>;
    skippedAll?: string;
    skippedAnswers?: string[];
    otherAnswers?: Record<string, string>;
    chatMessage?: any;
  }) {
    this.isQnACardVisible = false;
    setTimeout(() => {
      this.isQnADomStateActive = false;
    }, 850);

    this.handleMessageAction({ label: '', code: 'submit_qna' }, this.messages.length - 1, {
      qnaPayload: qnaPayload
    });
  }

  /**
   * Translates raw Q&A JSON into UI display format mapped to the original questions.
   */
  formatQAAnswers(questions: any[], payload: Record<string, any>): any[] {
    if (payload?.skippedAll == 'true') {
      let formattedAnswer = {
        questionText: '',
        answer: this.translate.instant('USER_OPTED_FOR_SKIP_ALL_OPTION'),
        isNotAnswered: false,
        skippedAll: true,
        type: 'info'
      };

      if (payload.skippedAllReason) {
        formattedAnswer.answer += `\n\n• Reason : ${payload.skippedAllReason}`;
      }

      return [formattedAnswer];
    }

    let answers = payload?.answers || payload;

    // Safely parse JSON strings dispatched from backend before processing
    if (typeof answers === 'string') {
      try {
        answers = JSON.parse(answers);
      } catch (e) {
        console.warn('Failed to parse answers JSON', e);
      }
    }

    if (!questions || !answers || typeof answers !== 'object' || Array.isArray(answers)) {
      return [];
    }

    return questions
      .map((q) => {
        let displayAnswer = answers[q.id];
        const otherText = payload.otherAnswers?.[q.id];

        if (!displayAnswer && otherText) {
          displayAnswer = '_other';
        }

        if (q.type === 'yes-no' && typeof displayAnswer === 'object' && displayAnswer !== null) {
          if (Array.isArray(displayAnswer)) {
            if (displayAnswer.length === 0) {
              displayAnswer = '';
            } else {
              displayAnswer = displayAnswer
                .map((opt) => {
                  let optionText = opt;
                  if (q.options) {
                    const foundOpt = q.options.find((o: any) => o.id === opt);
                    if (foundOpt) optionText = foundOpt.text;
                  }
                  return `• ${optionText}`;
                })
                .join('\n');
            }
          } else {
            const hasAnyAnswer = Object.keys(displayAnswer).length > 0;
            if (hasAnyAnswer) {
              displayAnswer = Object.keys(displayAnswer)
                .map((k) => {
                  const val = (displayAnswer as Record<string, unknown>)[k];
                  const label = String(val) === 'true' ? 'Yes' : 'No';
                  let optionText = k;
                  if (q.options) {
                    const foundOpt = q.options.find((o: any) => o.id === k);
                    if (foundOpt) optionText = foundOpt.text;
                  }
                  return `• ${optionText}: ${label}`;
                })
                .join('\n');
            } else {
              displayAnswer = ''; // Treat as completely empty
            }
          }
        } else if (Array.isArray(displayAnswer)) {
          if (displayAnswer.length === 0) {
            displayAnswer = '';
          } else {
            const processedArr = [...displayAnswer];

            if (otherText) {
              processedArr.push(`${this.translate.instant('OTHER')}: ${otherText}`);
            }

            if (processedArr.length === 0) {
              displayAnswer = '';
            } else {
              displayAnswer = processedArr
                .map((opt) => {
                  let optionText = opt;
                  if (q.options) {
                    const foundOpt = q.options.find((o: any) => o.id === opt);
                    if (foundOpt) optionText = foundOpt.text;
                  }
                  return `• ${optionText}`;
                })
                .join('\n');
            }
          }
        } else if (displayAnswer === '_other') {
          displayAnswer = `${this.translate.instant('OTHER')}: ${otherText}`;
        } else if (typeof displayAnswer === 'string' && q.options) {
          const foundOpt = q.options.find((o: any) => o.id === displayAnswer);
          if (foundOpt) {
            displayAnswer = foundOpt.text;
          }
        } else if (typeof displayAnswer === 'object' && displayAnswer !== null) {
          // Fallback for any other objects to prevent [object Object] rendering
          displayAnswer = JSON.stringify(displayAnswer, null, 2);
        }

        const isNotAnswered = !displayAnswer;
        return {
          questionText: q.text,
          answer: displayAnswer || this.translate.instant('NOT_ANSWERED'),
          type: q.type,
          isNotAnswered: isNotAnswered
        };
      })
      .filter((item: any) => !item.isNotAnswered);
  }
}
